import { awokenFaceRoomPx } from './awoken_face_room'
import { awokenBiteSpaceCutsBeat, awokenBiteSpaceRoomPx } from './awoken_bite_space'
import { prepareWallHuntGame, placeWallHuntGame, isWallHuntGame, recordWallHuntAim, recordWallHuntSpirits, pounceWallHunt } from './awoken_wall_hunt_game'
import { AWOKEN_SPIN_FRONT_PAW_OFFSET_PX, awokenPocketOrBehind, shouldChainAwokenPocketSpin } from './awoken_pocket_spin'
import { beastBody, beastWhiffCarry, stanceBodyGap, whiffCarryProgress } from './boss_body_envelope'
import { preparePlantedTravel, plantedTravelTarget } from './boss_planted_travel'
import { clearNeutralMovement, prepareNeutralMovement, updateNeutralMovement, usesNeutralMovementTrial } from './boss_neutral_movement'
import { advanceKnightGait, getKnightMove, prepareKnightGait, settleKnightGait, usesKnightGait, type KnightGaitWant } from './knight_gait'
import { prepareBossAttackTravel, settleBossAttackTravel } from './boss_attack_travel'
import {
  awokenSpacingLocksFacing, clearAwokenSpacing, prepareAwokenSpacing, spacingReachPx, spacingReaches, spacingWeight,
  updateAwokenSpacing, usesAwokenSpacingChoice, usesSpacingChoice,
} from './awoken_spacing_choice'
import { spacingAllTuning } from './spacing_all'
import { awokenFinaleLunge, awokenFinaleLungeSpeed, awokenFinaleRange, awokenFinaleStrings } from './awoken_finale_trial'
import { maulSetStopFor } from './exec_maulset_stop'
import { awokenBiteInPocket, awokenBiteLandingGapPx, awokenPocketRetreatGapPx, withoutAwokenPocketBites } from './awoken_bite_mouth'
import { rampageV5EntryAttack, advanceChoreo, rampageV5Debut, rampageV5PendingDebuts, rampageV5DebutSeen, rampageV5Strings, rampageV5TempoFromExecutes, settleAltitude, tallySpirits } from './awoken_rampage_v5'
import { advanceRoosterRoam, settleRoosterRoam } from './rooster_aerial_roam'
import { advanceRoosterVertical, settleRoosterVertical } from './rooster_vertical'
import { roosterClawHopPx } from './rooster_claw_hop'
import { prepareRoosterHop, roosterHopInAir, roosterHopLocksFacing, updateRoosterHopMove, usesRoosterHopMove } from './rooster_hop_move'
// ボスの状態遷移と「次の攻撃を決める」ロジック。
// Phase 4: attackPool を引数に取り、ラウンドロビン＋距離ヒューリスティックで攻撃選択。

import type { AttackDef, Boss, BossState, BossString, Player } from './types'
import { ARENA, arenaBoundsFor, arenaWalls, getArenaWidthMul, BACK_ATTACK, BOSS_BODY_WALL_INSET_PX, bossBodyBoundsFor, BOSS, BOSS_CORE, BOSS_EXECUTE_APPROACH_PX, COLLISION, FIXED_DT, RETALIATION } from './balance'
import { ATTACKS, getAttack } from './attacks'
import { KNIGHT_CROSS_LUNGE_MAX_PX, knightCrossForwardPx } from './knight_leap_slash'
import { KNIGHT_CHARGE_BRAKE_DISTANCE, KNIGHT_CHARGE_SCRAPE_MS, knightChargeRunDistance, knightChargeRunMs, knightChargeScrapeDistance, knightChargeStopX } from './knight_wall_charge'
import { getKnightCloseAnswer, getKnightSpacing, usesKnightSpearSpacing, knightSpearLungeGap, knightRoomBehind, knightCrossRetreatCap,
  KNIGHT_RETREAT_TRIGGER_PX, KNIGHT_RETREAT_TARGET_PX, KNIGHT_POST_ATTACK_RESPACE_TRIGGER_PX,
  KNIGHT_CROSS_PURSUIT_MS, getKnightWallChargeEarly, getKnightBackoff,
  KNIGHT_CROSS_WALL_ROOM_PX, KNIGHT_CROSS_MIX_RANGE_PX, KNIGHT_LEAP_MIX_RANGE_PX, getKnightLeapOdds, getKnightClosePity, knightStringWeightMul, KNIGHT_STALE_MS, getKnightStaleRunRoom,
  getKnightStaleCharge, trackKnightStale, knightChargeRoomPastPlayer } from './knight_spacing'
import { HOUND_PASS_ATTACK_ID, houndPassEntryPatch, houndPassOdds, houndPassPlan, houndPassReason,
  houndPassRunDistance, houndPassSkidDistance, trackHoundDrift } from './hound_pass_through'
import { awokenRushStudyTarget, isAwokenRushStudy, isAwokenChaseStudy, awokenRushStudyAttack, AWOKEN_CHASE_CUE_MS } from './awoken_rush_study'
import { getBossDefinitionById, attackPoolForBoss, bossCoreHalfWidth } from './bosses'
import { cannonFinisherToMorph } from './exec_cannon_finisher'
import './exec_jab_fix'   // 介錯の突き当ての溜め 600ms (既定・2026-10-10) を読み込み時に置く。ゲームも自動プレイの測定も boss.ts を通る
import { bossFinisherAttackId, execStunActive } from './exec_parry'
import { EXEC_BAIT_ENCORE_GAP_MS, encoreArmed } from './exec_bait'
import { bladeClapAttack, bladeFinisherV2On } from './blade_finisher_v2'
import { STUN_CUT, stunCutActiveRateMax, stunCutBridgeMs, stunCutDirect, stunCutOn, stunCutRate, stunCutWarpsRecovery } from './stun_cut'
import { BOSS_ATTACK_TIMELINES } from './boss_pose_timeline'
const FINISHER_DROP_MS = STUN_CUT.dropMs
import { execApproachMode, finisherStepAt, finisherStepPlan, finisherStepWanted } from './exec_finisher_step'
import { act2BlinkOn, stepAct2Blink } from './exec_act2_blink'
import { ROAR_CENTER_ATTACK_ID, roarCenterApplies, roarCenterLocksFacing, roarCenterWalkSpeed, stepRoarCenter } from './exec_roar_center'
import { AWOKEN_DEVOUR_BASE_ID, awokenDevourAttack, awokenDevourEnabled, awokenDevourGapAt } from './awoken_devour'
import { brideCoverGapAt, brideParriedShiftPx, execUniqueAttack, execUniqueOn, execUniquePoseAt, KNIGHT_BACKTURN, knightChargeAfterShiftPx, type ExecUniquePlan } from './exec_unique'
import { lunaWalkBossWalkMul, lunaWalkPounceExtraPx } from './player_walk_new'
import { tickBladeClap } from './blade_dancer_clap'
import { advanceBladeBackStep, BLADE_BACK_STEP_COMMIT_BONUS_PX, bladeBackStepLockOwns, bladeBackStepSettled } from './blade_back_step'
import { bossRiseHoldMs } from './boss_rise'
import {
  currentStandoffBeat, inStandoffBeat, pickStandoffBeat, standoffResetVelocity,
} from './boss_standoff'
import {
  EXECUTIONER, advanceExecutionerStep, cannonRangeTuning, executionerMorphTiming,
  executionerSidestepTargetX, mulsFor,
  onAttackFinished, getExecutionerStepStyle, rangeTuningFor, stepMorph, type ExecutionerStepState,
  executionerStringEnabled,
} from './executioner_weapon'

// 攻撃間の待ち時間を毎サイクル揺らす (固定だとメトロノーム化)。 attackCount 由来で決定的。
function hash01(n: number): number { const s = Math.sin(n * 127.1) * 43758.5453; return s - Math.floor(s) }
function idleGapMsFor(attackCount: number): number {
  return BOSS.idleGapMinMs + hash01(attackCount * 2.3 + 0.7) * (BOSS.idleGapMaxMs - BOSS.idleGapMinMs)
}

// 最終部屋 (= executesTaken が roomCount-1 に到達) では攻撃テンポを上げる (クライマックス)。
//   def.finalRoomTempoMul (<1 で速い) を攻撃間の待ち時間にだけ掛ける。 予告 (chargeMs) は縮めない
//   = 読みやすさは保ったまま「攻撃の回転」だけ上げる (公平)。 未指定/最終部屋以外は等倍。
//   刑吏 (roomCount=2) は致命1回後の幕2頭から、技・長い連の解禁とこのテンポ上昇が同時に来る (2026-08-06裁定)。
//   idleGapMul (2026-07-07 覚醒王): 攻撃間の「間」だけの per-boss 倍率 (>1=間を作る)。
//   「ずっと忙しい=メリハリがない」対策 — 長い間は retaliation (割り込み反撃) が緊張として守る。
//   未指定=1 (既存ボス不変)。
export function attackGapMsFor(
  def: { roomCount?: number; finalRoomTempoMul?: number; idleGapMul?: number } | undefined,
  attackCount: number,
  executesTaken: number,
  // テンポ上げを始める致命回数。未指定 = 最終幕だけ (既定)。覚醒王の第5案の比較 (DEV) だけが 1 (= 幕2から) を渡す。
  tempoFromExecutes?: number,
): number {
  const base = idleGapMsFor(attackCount) * (def?.idleGapMul ?? 1)
  const isFinalRoom = def?.roomCount != null && executesTaken >= (tempoFromExecutes ?? def.roomCount - 1)
  const mul = isFinalRoom ? (def?.finalRoomTempoMul ?? 1) : 1
  return base * mul
}

// いま実際に使われている溜め時間 (ms)。連の拍の chargeOverrideMs があればそれ、無ければ技の定義の chargeMs。
//   絵・オーラ・体の膨らみなど「溜めの進み具合」を割る側は、必ずこれで割る (定義の値で割ると、溜めを短くした拍で
//   予告の終わりに満ちきらず、当たりの瞬間に跳ねる。2026-10-10 介錯の地割りの連で発覚)。
export function effectiveChargeMs(boss: Pick<Boss, 'currentAttack' | 'currentString' | 'beatIndex'>): number {
  const atk = boss.currentAttack
  if (!atk) return 0
  return boss.currentString?.beats[boss.beatIndex]?.chargeOverrideMs ?? atk.chargeMs
}

export type BossUpdateResult = {
  boss: Boss
  enteredActive: boolean
  // 介錯の無害な突き飛ばしが発生したtickだけ返す。他ボスと通常経路は undefined のまま。
  player?: Player
}

// 宵渡り (blink) のチューニング。 spec 2026-06-11 §4 フェアネス鉄則:
//   再出現は必ず見せる / 追撃の予兆は再出現の「後」(通常 telegraph 経由でフル) / 連発禁止。
const BLINK_OUT_MS = 420        // 渦になって消えるまで
// 再出現の見せ時間 (≥450ms の反応の床)。 sprites.ts の分岐予告 予備動作を同じ尺で着地させるため export。
//   ⚠️参照は sprites.ts → boss.ts の一方向のみ (boss.ts は sprites.ts を import しない = 循環なし)。
export const BLINK_REAPPEAR_MS = 470
const BLINK_REAPPEAR_DIST = 150 // プレイヤーの反対側、 この距離に出る
// 2026-07-01 rev 2: 250ms → 90ms (ユーザー実プレイで「部屋3 で blink 出ない」 指摘)。
//   原因: 部屋3 は finalRoomTempoMul 0.35 で attackGap = 52-122ms (idleGap 150-350ms × 0.35)、
//     BLINK_MIN_IDLE_MS 250ms より短い = idle 250ms 経過前に必ず attack が始まって blink 判定に到達しない。
//   90ms なら部屋3 の attackGap 上限 (122ms) でも通る大半のケースで blink 判定通る。
//   唐突感 (idle 90ms でワープ) は blink の反応の床 (BLINK_REAPPEAR_MS 470ms) で担保。
const BLINK_MIN_IDLE_MS = 90
// idle/recovery の向き直り不感帯 (px)。プレイヤーがボス中心を跨いだ直後の毎tick鏡像反転チラツキを止める。
//   全ボス共通 (共通経路への追加 = feedback_converge_on_reference)。24px ≈ プレイヤー幅の半分。
const FACING_FLIP_DEADBAND_PX = 24
// 壁に背をつけた主人公だけは不感帯の中でも向き直る (2026-10-02 AI点検の候補3「壁際でボスに重なると攻撃が当たらない」)。
//   壁とボスの間に挟まった主人公は中心を跨いで往復できない＝チラつかない。旧は不感帯のせいでボスが部屋の中央を
//   向いたまま振り、刃 (前方 localFromPx 8〜12 から) が背中側の主人公に一度も届かなかった。
const WALL_PIN_PX = 4
function turnTowardPlayer(boss: Boss, player: Player): Boss['facing'] {
  const dxp = player.x - boss.x
  if (Math.abs(dxp) > FACING_FLIP_DEADBAND_PX) return dxp < 0 ? 'left' : 'right'
  const walls = arenaBoundsFor(boss.id)
  if (player.x <= walls.leftWall + WALL_PIN_PX && dxp <= 0) return 'left'
  if (player.x >= walls.rightWall - WALL_PIN_PX && dxp >= 0) return 'right'
  return boss.facing
}

// 連撃「ヒット hitIndex → 次ヒット」へ移る間 (ms)。 comboGapsMs (per-hit 配列) 優先・
//   無ければ comboGapMs (単一値) にフォールバック。 どちらも無ければ undefined (= 連撃終了)。
//   処刑人 B4/C7 の可変リズム (mash-parry trap) 用。
function comboGapForHit(atk: AttackDef, hitIndex: number): number | undefined {
  return atk.comboGapsMs?.[hitIndex] ?? atk.comboGapMs
}

// ===== DEV 検収フック (2026-07-07 覚醒王ビルドで追加・本番は誰もセットしない=挙動不変) =====
//   strings 持ちボス (騎士/花嫁/覚醒王) は単技プール (__soloAttack) を迂回して連を選ぶため、
//   技/連を1本ずつ検証するには string 側の単独化が要る (feedback_test_single_motion_isolation)。
//   - debugSoloStringId: この id の連だけを出す (null=解除)。
//   - debugBypassStrings: true の間 strings を無視して attackPool 経路へ落とす (__soloAttack 用)。
let debugSoloStringId: string | null = null
let debugBypassStrings = false
export function setDebugSoloString(id: string | null): void { debugSoloStringId = id }
// 割り込み反撃 (殴られ続けたら待ちを打ち切って応手・06-12 combat-feel-v2 §4.1) は 10-02 に全ボスで止めた
//   (ユーザー「これはいらない気がする」→「持っている3体（騎士・介錯・覚醒王）すべて外す」)。背後応手は別 (backAttackId)。
//   DEV ?retaliation=on で戻す。retaliationAttackId のデータは残す。
let retaliationEnabled = false
export function setRetaliationEnabled(v: boolean): void { retaliationEnabled = v }
export function setDebugBypassStrings(on: boolean): void { debugBypassStrings = on }

// DEV ?altAttacks=<id>,<id>,...: 技 (または連) を A→B→A→B… の順に出す検収用 (2026-10-08 戴冠獣の技の見比べ)。
//   各要素は連の id (例 hound-triple) か技の id (例 houndGrab)。技の id は「その技から始まる連」へ置き換えるので、
//   三連 (houndTripleSwipe1 を指定しても hound-triple の3段) は1つの技として最後まで出る。連が無い技は1本だけの連で出す。
//   解禁 (unlockAtExecutes) は無視 = 幕1から出せる。技と技の間の待機・間合いは通常のまま。配布版は誰も呼ばない。
//   技から外した連 (定義の altOnlyStrings・10-08 戴冠獣の三連) も、ここで直接指定すれば出る。
//   連を持たないボスは pickNextAttack 側で技をそのまま順に出す。
let debugAltTokens: string[] = []
let debugAltIndex = 0
export function setDebugAltAttacks(tokens: string[]): void { debugAltTokens = tokens.filter((t) => t.length > 0); debugAltIndex = 0 }
function nextAltToken(boss: Boss): string | undefined {
  if (debugAltTokens.length === 0) return undefined
  if (boss.attackCount === 0) debugAltIndex = 0   // やり直し・新しい戦いは必ず A から
  const token = debugAltTokens[debugAltIndex % debugAltTokens.length]!
  debugAltIndex += 1
  return token
}
function altStringFor(token: string, strings: BossString[]): BossString | undefined {
  const byId = strings.find((s) => s.id === token && s.blinkOnly !== true)
  if (byId) return byId
  const byFirstBeat = strings.find((s) => s.beats[0]?.attackId === token && s.blinkOnly !== true)
  if (byFirstBeat) return byFirstBeat
  return ATTACKS[token] ? { id: `alt-${token}`, beats: [{ attackId: token }], weight: 1 } : undefined
}

// 介錯のステップを含む既存ゲート。通常の連続後退だけを切る比較とは分けて維持する。
let bossBackStep: boolean = BOSS.bossBackStep
export function setBossBackStep(on: boolean): void { bossBackStep = on }
export function isBossBackStep(): boolean { return bossBackStep }
function getBossBackStep(): boolean { return bossBackStep }

// 09-26: 通常は近ければ構えて待つ。立て直しはこの比較に関係なく従来の条件・速度で行う。
let neutralBackOff: boolean = BOSS.neutralBackOff
export function setBossNeutralBackOff(on: boolean): void { if (import.meta.env.DEV) neutralBackOff = on }
export function isBossNeutralBackOff(): boolean { return import.meta.env.DEV ? neutralBackOff : BOSS.neutralBackOff }

let attackStopAtReach: boolean = BOSS_CORE.attackStopAtReach

// 帯 (芯の外側) で立て直すくじの当たり確率。騎士の 09-28b「切り下がりは槍の内側に入られた時に40%」(boss.ts crossRoll < 0.4) に合わせた。
export const OVERLAP_REGAIN_BAND_CHANCE = 0.4
// 間合いの立て直し (2026-09-18・DEV 比較 ?bossRegain=1)。既定 = balance.ts の BOSS.overlapRegain*。
let overlapRegain = {
  enabled: BOSS.overlapRegain as boolean, holdMs: BOSS.overlapRegainHoldMs as number,
  speedMul: BOSS.overlapRegainSpeedMul as number, deferMs: BOSS.overlapRegainDeferMs as number,
  // 介錯の後退の仕方 (2026-09-18・?execRegain=)。🔵 既定 walk＝ユーザー裁定「AでOK」(2026-09-18)。
  //   walk = 他ボスと同じく歩いて下がる (4コマ歩きを逆再生) / step = 56px の一歩後退を冷却なしで連発
  //   (最初の比較版・実機所見「調整してます」感) / leap = 好みの間合いまで一度で跳び退く (1回・最大 REGAIN_LEAP_MAX_PX)。
  execStyle: 'walk' as ExecRegainStyle,
  // 帯をボスの胴の幅へ広げる (2026-10-06・bosses.ts overlapRegainBandPx・DEV ?regainBand=off|<px>)。
  //   null = 定義どおり (未指定のボスは芯の帯のまま) / 'off' = 全ボス芯の帯 (旧) / 数字 = 全ボスその幅。
  bandOverride: null as 'off' | number | null,
  // 芯の外・帯の内 (芯の帯〜overlapRegainBandPx) で下がるのは「ときどき」(2026-10-06 ユーザー裁定 Q2「ときどき下がる」)。
  //   待機1回につき1回だけくじを引く (騎士の「槍の内側に入られた時に 40%」09-28b と同じ形・同じ値)。DEV ?regainChance=0〜1。
  //   芯の帯の内側 (従来の立て直し・09-18) は今までどおり必ず下がる。
  bandChance: OVERLAP_REGAIN_BAND_CHANCE,
}
export type ExecRegainStyle = 'step' | 'walk' | 'leap'
// leap の上限 = 瞬歩の最大歩幅と同じ (等身 1.6 基準)。
const REGAIN_LEAP_MAX_PX = 176
export function setOverlapRegain(cfg: Partial<typeof overlapRegain>): void { overlapRegain = { ...overlapRegain, ...cfg } }
export function getOverlapRegain(): Readonly<typeof overlapRegain> { return overlapRegain }
// ?regainBand=off|<px> / ?regainChance=0〜1 (2026-10-06・開発版だけ)。src/game.ts の他の比較引数と同じく URL から読む
//   (game.ts は古い player-combo-1001 の claim と重なるので、ここで読む)。旧の挙動 = ?regainBand=off。
if (import.meta.env.DEV && typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search)
  const band = params.get('regainBand')
  if (band === 'off') setOverlapRegain({ bandOverride: 'off' })
  else if (band !== null && Number.isFinite(Number(band)) && Number(band) > 0) setOverlapRegain({ bandOverride: Number(band) })
  const chance = params.get('regainChance')
  if (chance !== null && chance !== '' && Number.isFinite(Number(chance)) && Number(chance) >= 0 && Number(chance) <= 1) {
    setOverlapRegain({ bandChance: Number(chance) })
  }
}
// 立て直しの帯 (ボス中心と主人公の中心の距離 px)。芯の帯 (芯半幅+主人公半幅) より狭くはしない。
export function overlapRegainBandFor(boss: Boss): number {
  const coreGap = bossCoreHalfWidth(boss) + BOSS_CORE.playerHalfWidth
  const override = overlapRegain.bandOverride
  if (override === 'off') return coreGap
  const band = typeof override === 'number' ? override : getBossDefinitionById(boss.id)?.overlapRegainBandPx
  return band != null ? Math.max(coreGap, band) : coreGap
}
// 帯で立て直すかのくじ。待機1回 (同じ attackCount の間) は同じ答え＝待機中に何度も引き直さない。
//   hash は宵渡りの発動判定 (下の idle 節) と同じ作り。種を変えて間の長さ (idleGapMsFor) と相関させない。
export function overlapRegainBandRoll(boss: Pick<Boss, 'attackCount'>): number {
  return hash01(boss.attackCount * 3.7 + 0.29)
}
// 絵の側 (sprites.ts) が「介錯が歩いて立て直している最中」かを知るための判定。
export function isExecutionerRegainWalk(boss: Boss): boolean {
  return !!boss.exec && !boss.exec.step && boss.state === 'idle'
    && ((overlapRegain.enabled && overlapRegain.execStyle === 'walk' && (boss.regainActive ?? false))
      // 幕2の頭に真ん中へ歩いて下がる間 (咆哮の新版の既定・src/exec_roar_center.ts) も同じ歩きの絵 (逆に回す)。
      || boss.roarCenter?.walking === true)
}

// 背後応手のしきい値 (DEV 比較 ?backMs=)。null = 定義どおり (王・騎士・花嫁・介錯 80〜100ms / 覚醒王は BACK_ATTACK 700ms)。
let backAttackThresholdOverrideMs: number | null = null
export function setBackAttackThresholdOverride(ms: number | null): void { backAttackThresholdOverrideMs = ms }
export function backAttackThresholdMsFor(definition: { backAttackThresholdMs?: number } | undefined): number {
  return backAttackThresholdOverrideMs ?? definition?.backAttackThresholdMs ?? BACK_ATTACK.behindThresholdMs
}
// 背後の応手を続けて出す上限 (BossDefinition.backAttackMaxChain・2026-10-10)。既定 = 上限を効かせる (配布版)。
//   false = 旧 (上限なし・応手の隙が終わるたびにまた応手) = DEV ?houndBackChain=old。上限を持つのは今は戴冠獣だけ。
let backAttackChainCapOn = true
export function setBackAttackChainCap(enabled: boolean): void { backAttackChainCapOn = enabled }
export function setBossApproachStopMode(mode: 'reach' | 'legacy'): void {
  attackStopAtReach = mode === 'reach'
}

// 既定は導入前の芯。reach分岐は09-15ユーザー却下版のDEV比較用。
export function bossAttackStopGap(boss: Boss, atk: AttackDef | null): number | null {
  // 却下版の王の例外も、過去比較を明示した時だけ再現する。
  if (atk?.passThroughBody || (attackStopAtReach && atk?.id === 'houndLunge')) return null
  const coreGap = bossCoreHalfWidth(boss) + BOSS_CORE.playerHalfWidth
  if (!attackStopAtReach || !atk || atk.playerLethal || atk.bossFinisher) return coreGap
  if (atk.approachStopGapPx != null) return Math.max(coreGap, atk.approachStopGapPx)
  if (atk.positionEvadable || atk.crossArena || atk.range <= 0) return coreGap
  const reachGap = attackApproachDistance(atk) - (atk.gapCloseBuffer ?? BOSS.gapCloseBuffer)
  return Math.max(coreGap, Math.min(BOSS_CORE.attackStopMaxGapPx, reachGap))
}

// ボス自身の前進だけを制限する。既に近すぎても押し戻さず、背後へ抜けた主人公は追わない。
//   holdInside = 主人公が前にいて既に芯の内側なら、その場で止める (押し戻しはしない)。
//   戻りの前進 (recoveryDriftPx) だけが使う: 無いと芯の 43px より近い時だけ止めが効かず、
//   花嫁の掴み・致命の戻りが主人公の体を抜けて背中側まで出ていた (rel 41px → -2px・10-18 測定)。
function clampToBossCoreFront(
  lx: number, fromX: number, playerX: number, dir: 1 | -1, atk: AttackDef | null, boss: Boss,
  holdInside = false,
): number {
  const bodyGap = !atk?.passThroughBody ? stanceBodyGap(boss, dir) : undefined
  const minGap = bodyGap ?? bossAttackStopGap(boss, atk)
  if (minGap == null) return lx
  const limit = playerX - dir * minGap          // 主人公の手前で止まる位置
  if (!attackStopAtReach && bodyGap === undefined) {
    if ((limit - fromX) * dir < 0) return holdInside && (playerX - fromX) * dir >= 0 ? fromX : lx
  } else {
    if ((playerX - fromX) * dir < 0 || (lx - fromX) * dir <= 0) return lx
    if ((limit - fromX) * dir <= 0) return fromX
  }
  return (lx - limit) * dir > 0 ? limit : lx
}

// 待機へ入る tick で主人公の方へ向き直る (2026-10-11 夜に比較版・10-11 朝の答え idle-face-fix「配布版へ」で既定に。DEV ?idleFaceFix=0 で旧へ)。
//   旧は向き直りが次の tick の頭 (reFaceNow の idle 側) なので、技の終わりで主人公と反対を向いていると、
//   待機の最初の1コマだけ古い向きで描かれてから反転した (戴冠獣の駆け抜けで頭が約 205px 飛んで戻った物と同じ作り・commit 090d145e)。
//   直しは「次の tick の頭で必ず起きる向き直り」を1 tick 前へ寄せるだけ: 同じ条件 (間合いの跳び・咆哮の歩きの最中は向きを保つ) と
//   同じ不感帯 (turnTowardPlayer) を使う。背中を見せる隙 (recovery 中の向きの固定) は recovery の中なので縮まない。
//   調べ = docs/research/2026-10-11-idle-entry-facing-audit.md。
let idleEntryFaceFix = true
export function setIdleEntryFaceFix(on: boolean): void { idleEntryFaceFix = on }
export function idleEntryFaceFixOn(): boolean { return idleEntryFaceFix }
export function faceOnIdleEntry(prev: Boss, next: Boss, player: Player): Boss {
  if (prev.state === 'idle' || next.state !== 'idle' || next.hp <= 0) return next
  if (awokenSpacingLocksFacing(next) || roarCenterLocksFacing(next) || roosterHopLocksFacing(next)) return next
  const facing = turnTowardPlayer(next, player)
  return facing === next.facing ? next : { ...next, facing }
}

export function updateBoss(boss: Boss, player: Player, attackPool: string[]): BossUpdateResult {
  const prepared = prepareWallHuntGame(boss)
  const base = updateBossBase(prepared, player, attackPool)
  const result = idleEntryFaceFix ? { ...base, boss: faceOnIdleEntry(prepared, base.boss, player) } : base
  let next = keepBossBodyOnScreen(trackExecutionerHazardPending(prepared, result.boss))
  // 介錯が砲を持って致命へ入る時は、先に砲→刃へ組み変わる (11-01 作者の答え fin = A・src/exec_cannon_finisher.ts)。
  next = cannonFinisherToMorph(prepared, next, player)
  // 崩れを見て早回しにした振り・戻り (src/stun_cut.ts): 1 コマで動く量を抑える (踏み込み・寄りを早回しで詰めると跳ぶ)。
  if (next.cutRecovery && (next.state === 'active' || next.state === 'recovery')) {
    const d = next.x - prepared.x
    if (Math.abs(d) > STUN_CUT.maxStepPx) next = { ...next, x: prepared.x + Math.sign(d) * STUN_CUT.maxStepPx }
  }
  // 戴冠獣の駆け抜け (10-11 から配布版の既定・DEV ?houndPassThrough=0 で切る): 流れの向きと時間を数える (切っている間は素通り)。
  next = trackHoundDrift(prepared, next, FIXED_DT * 1000, player.x)
  if (isWallHuntGame(prepared) && prepared.currentAttack?.id === 'feralWallDash'
    && prepared.state === 'active' && next.state !== 'active'
    // 崩れを見て致命へ移った時 (src/stun_cut.ts) は戻りの跳びへ繋がない。
    && !next.currentAttack?.bossFinisher) {
    // The wall hold IS the return telegraph. No ground recovery or extra beat gap.
    next = { ...next, currentAttack: getAttack('feralWallDashBack'), state: 'telegraph', stateElapsed: 0,
      beatIndex: next.currentString ? next.beatIndex + 1 : 0, comboHitIndex: 0 }
  }
  if (next.id === 'crowned-king-awoken' && next.state === 'telegraph'
    && (prepared.state !== 'telegraph' || prepared.currentAttack?.id !== next.currentAttack?.id)
    && !awokenPocketOrBehind(next, player)) next = { ...next, awokenSpinStreak: 0 }
  return { ...result, boss: placeWallHuntGame(pounceWallHunt(recordWallHuntSpirits(prepared, recordWallHuntAim(prepared, prepareWallHuntGame(next), player)), player)) }
}

// ボスだけを壁の手前で止める (balance.ts BOSS_BODY_WALL_INSET_PX・2026-10-02 AI点検の候補1)。
//   中の動き (突進・後退・飛び退き) は部屋の壁で計算し、最後にここで体の幅ぶん内側へ収める。
export function keepBossBodyOnScreen(boss: Boss): Boss {
  if (!BOSS_BODY_WALL_INSET_PX[boss.id]) return boss
  const b = bossBodyBoundsFor(boss.id)
  const x = Math.max(b.leftWall, Math.min(b.rightWall, boss.x))
  return x === boss.x ? boss : { ...boss, x }
}

// 介錯: 自分の床ハザードが着弾し終わるまでの残り時間 (exec.hazardPendingMs) を進める。
//   ハザードは telegraph 突入の tick に game.ts が spawnZoneHits で出す。同じ式で寿命を見積もる。
export function trackExecutionerHazardPending(prev: Boss, next: Boss): Boss {
  if (!next.exec) return next
  let pending = Math.max(0, (prev.exec?.hazardPendingMs ?? 0) - FIXED_DT * 1000)
  const atk = next.currentAttack
  const enteredTelegraph = next.state === 'telegraph'
    && (prev.state !== 'telegraph' || prev.currentAttack?.id !== atk?.id)
  if (enteredTelegraph && atk?.hazardSpawns?.length) {
    const chargeMs = next.currentString?.beats[next.beatIndex]?.chargeOverrideMs ?? atk.chargeMs
    for (const s of atk.hazardSpawns) {
      pending = Math.max(pending, Math.max(0, s.telegraphMs + (chargeMs - atk.chargeMs)) + s.activeMs)
    }
  }
  if (pending === (next.exec.hazardPendingMs ?? 0)) return next
  return { ...next, exec: { ...next.exec, hazardPendingMs: pending } }
}

// 崩れを見た時、振りを早回しせずその場で戻りへ入る技 (src/stun_cut.ts): 走り抜け・壁ぎわの突進・切り下がり・入れ替わる技と、
//   当たりの残りが長い技 (走り続ける突進)。走りを早回しすると 1 コマに大きく動く (瞬間移動に見える)。
function stunCutStopsInPlace(atk: AttackDef, boss: Boss): boolean {
  if (atk.id === 'knightWallCharge' || atk.id === 'lanceCross' || atk.id === HOUND_PASS_ATTACK_ID || atk.swapsSides) return true
  // 覚醒王の突進 (走り抜ける版)・踏み込みの長い突進 (戴冠獣の飛びかかり 260px・突進 330px など)
  if (atk.passThroughBody || isAwokenRushStudy(boss) || isAwokenChaseStudy(boss) || (atk.lungeDistance ?? 0) >= STUN_CUT.stopLungePx) return true
  return atk.activeMs - boss.stateElapsed * 1000 > STUN_CUT.warpActiveMaxMs
}

// 打ち切った技の戻りの見せ方 (src/stun_cut.ts・10-12 F-1「早送りに見える」の既定): 戻りの絵の並びを順に、絵ごとに等速で少しだけ見せ、
//   次の絵の頭へ進む (絵と絵の間の長い保ちだけを飛ばす)。戻りの途中から致命へ切ると、戻りの絵 → 致命の構えが1コマで大きく跳んだ
//   (騎士の突き 兜 78px・介錯の据えの振り 207px)。絵の並びを順に通れば、跳びは普段の戻りと同じ大きさで済む。
function beatRecoveryMs(boss: Boss, atk: AttackDef): number {
  return boss.currentString?.beats[boss.beatIndex]?.recoveryOverrideMs ?? atk.recoveryMs
}
/** その技の戻りの絵の頭の時刻 (ms・戻りの頭から・同じ絵が続くキーはまとめる)。登録が無ければ [0]。 */
function cutRecoveryKeyStartsMs(boss: Boss, atk: AttackDef, recoveryMs: number): number[] {
  const keys = (BOSS_ATTACK_TIMELINES[boss.id]?.[atk.id] ?? []).filter(k => k.phase === 'recovery').sort((a, b) => a.at - b.at)
  const out: number[] = []
  let last: string | undefined
  for (const k of keys) if (k.image !== last) { out.push(k.at * recoveryMs); last = k.image }
  return out.length ? out : [0]
}
/** 戻りの絵1枚を見せる長さ (ms・等速)。bridgeMs を絵の枚数で割り、STUN_CUT.poseHoldMinMs〜poseHoldMaxMs に収める。 */
function cutPoseHoldMs(boss: Boss, atk: AttackDef, recoveryMs: number): number {
  const n = cutRecoveryKeyStartsMs(boss, atk, recoveryMs).length
  return Math.max(STUN_CUT.poseHoldMinMs, Math.min(STUN_CUT.poseHoldMaxMs, stunCutBridgeMs(boss.id) / n))
}

function updateBossBase(boss: Boss, player: Player, attackPool: string[]): BossUpdateResult {
  // 大暴れ第5案: 台本の技を抜けたら高さと台本を片付ける (崩れた時は床まで落とす)。他ボスは素通り。
  if (!isWallHuntGame(boss)) boss = settleAltitude(boss)
  // 鶏の宙廻り (ラボ専用): 溜めを離れたら経路を片付ける。他ボスは roosterRoam を持たないので素通り。
  boss = settleRoosterRoam(boss)
  boss = settleRoosterVertical(boss)
  boss = prepareNeutralMovement(boss)
  boss = prepareKnightGait(boss)
  boss = prepareAwokenSpacing(boss)
  boss = prepareRoosterHop(boss)
  boss = preparePlantedTravel(prepareBossAttackTravel(boss), player)
  // 致命中はstagger窓そのものを凍結する。復帰だけを止めると、致命終了と同時に
  // 残り時間ゼロでidleへ戻り、操作不能中に作られた理不尽な被弾を残してしまう。
  const freezeStaggerClock = boss.state === 'staggered' && player.state === 'executing'
  // 崩れを見て打ち切った戻りは早回し (src/stun_cut.ts)。
  const cutRate = (boss.state === 'recovery' || boss.state === 'active') && boss.cutRecovery ? boss.cutRecovery.rate : 1
  let next: Boss = { ...boss, stateElapsed: boss.stateElapsed + (freezeStaggerClock ? 0 : FIXED_DT * cutRate),
    ...(usesKnightSpearSpacing(boss) ? { knightRetreatRecentMs: Math.max(0, (boss.knightRetreatRecentMs ?? 0) - FIXED_DT * 1000),
      ...(boss.state === 'staggered' ? {} : trackKnightStale(boss, FIXED_DT * 1000)) } : {}) }
  // ボスの「歩ける範囲」= per-boss 壁 (騎士は背景前景に乗らないよう内側に絞る)。 未登録ボスは ARENA 既定。
  //   ※ 位置クランプにのみ使う。 arenaCenter/nearWall 等の AI ヒューリスティックは ARENA 据え置き (狭域内では無害)。
  const bounds = bossBodyBoundsFor(next.id) // 介錯は体の幅ぶん壁の手前 (BOSS_BODY_WALL_INSET_PX・他のボスは arenaBoundsFor と同じ)

  // 割り込み反撃の素材を老化させ、 窓の外は捨てる。 クールダウンも常時減衰 (combat-feel-v2 §4.1)。
  //   2026-07-01: blinkCooldownMs も常時減衰へ移動 (旧: idle 中のみ)。 花嫁は string 連鎖で idle が
  //   細切れ = 実質「攻撃間の idle 時間合計が cooldown」 となり、 5s 設定でも実プレイでは 30-60s
  //   かかっていた (ユーザー実プレイで「1〜2 回しか見てない」 指摘)。 常時減衰なら絶対時間で発動可。
  next = {
    ...next,
    recentHitAgesMs: boss.recentHitAgesMs
      .map((a) => a + FIXED_DT * 1000)
      .filter((a) => a <= RETALIATION.windowMs),
    retaliationCooldownMs: Math.max(0, boss.retaliationCooldownMs - FIXED_DT * 1000),
    postExecuteInvincMs: Math.max(0, boss.postExecuteInvincMs - FIXED_DT * 1000),
    blinkCooldownMs: Math.max(0, boss.blinkCooldownMs - FIXED_DT * 1000),
  }

  // 請われぬ介錯「時間の床」(2026-09-05): 砲形態でいる間だけ毎tick積み上げ、刃形態では0へ戻す。
  //   技中・idle・変形中を問わず進む＝この常時ブロックに置く (staggered 中も含む)。
  if (next.exec) {
    next = {
      ...next,
      exec: {
        ...next.exec,
        cannonHeldMs: next.exec.held === 'cannon' ? next.exec.cannonHeldMs + FIXED_DT * 1000 : 0,
      },
    }
  }

  // 背面滞在の計測 (§4.3)。 idle/recovery は毎tick向き直るので、 実質 telegraph/active 中に積もる。
  //   新しい攻撃に入るとき (telegraph 突入 patch) にリセット = per-attack の計測。
  const facingDir = boss.facing === 'right' ? 1 : -1
  // 台本の技 (大暴れ第5案・鶏の宙廻り) は左右へ跳び回るので数えない (数えると倒れ込みの直後に必ず振り向き技が出る)。
  const canAccumulateBehind = (boss.state === 'telegraph' || boss.state === 'active' || boss.state === 'comboGap')
    && !boss.currentAttack?.choreography
    // 左右を入れ替える技 (戴冠獣の駆け抜け・swapsSides) も数えない: 抜けた後に主人公が背中側に来るのは設計どおり。
    && !boss.currentAttack?.swapsSides
  if ((player.x - boss.x) * facingDir <= -BACK_ATTACK.behindDistancePx && canAccumulateBehind) {
    next = { ...next, behindMs: boss.behindMs + FIXED_DT * 1000 }
  }

  // 間合いの立て直し (BOSS.overlapRegain): 芯の帯 (芯半幅+15) に居られた時間を状態を問わず数え
  //   (技の最中に潜り込まれた分も含む)、idle でしきい値を超えていれば latch する。
  //   解除は idle の歩き節 (好みの間合いまで離れた時) か idle を抜けた時。
  //   2026-10-06: 帯はボス別 (overlapRegainBandPx・未指定は芯の帯のまま)。芯の帯の内側は必ず、
  //   芯の外・帯の内 (ボスが自分の踏み込みで止まる 43px 付近) は待機1回につき bandChance の確率で下がる。
  {
    const coreGap = bossCoreHalfWidth(next) + BOSS_CORE.playerHalfWidth
    const dist = Math.abs(player.x - next.x)
    const insideNow = dist < overlapRegainBandFor(next)
    const regainInsideMs = insideNow ? (boss.regainInsideMs ?? 0) + FIXED_DT * 1000 : 0
    const latch = regainInsideMs >= overlapRegain.holdMs
      && (dist < coreGap || overlapRegainBandRoll(next) < overlapRegain.bandChance)
    const regainActive = !usesKnightSpearSpacing(boss) && overlapRegain.enabled && boss.state === 'idle'
      && ((boss.regainActive ?? false) || latch)
    const regainDeferredMs = regainActive ? (boss.regainDeferredMs ?? 0) + FIXED_DT * 1000 : 0
    if (regainInsideMs !== (boss.regainInsideMs ?? 0) || regainActive !== (boss.regainActive ?? false)
      || regainDeferredMs !== (boss.regainDeferredMs ?? 0)) {
      next = { ...next, regainInsideMs, regainActive, regainDeferredMs }
    }
  }

  // idle/recovery はプレイヤー方向へ向き直す。telegraph/active 中はロック。
  //   ★不感帯 (2026-07-06 チラツキ対策): 密着ですれ違い続けると毎tick鏡像反転して高速チラツキになる。
  //   ボス中心から一定px を越えて反対側に出た時だけ向き直す (跨いだ瞬間の連続反転を止める)。
  //   ★ comboLunge 攻撃 (裾乱れ) は recovery でも向きを保持: 前進で追い越しても振り向かない
  //     = 追い越した瞬間「背中を晒す」flank窓になる (バグの反転→設計の隙へ) & recovery 中の反転チラツキを断つ (2026-07-10)。
  //   ★ 獣比較 (bodyModel=beast): 空振りの勢いで相手を通り越した回復中も向きを保つ = 背中を晒す窓。
  // 覚醒王の間合いの一手 (09-27 採用): 後ろ跳びの宙では振り向かない (他ボス・DEV `?spacing=old` では常に false)。
  const reFaceNow = (boss.state === 'idle' && !awokenSpacingLocksFacing(boss) && !roarCenterLocksFacing(boss) && !roosterHopLocksFacing(boss) && boss.bladeBackStep === undefined)
    || (boss.state === 'recovery' && !boss.currentAttack?.locksFacingDuringRecovery && !boss.currentAttack?.comboLunge && !beastBody(boss)
      && !isAwokenRushStudy(boss) && !isWallHuntGame(boss)
      && !(boss.id === 'vigil-knight' && (boss.currentAttack?.id === 'lanceCross' || boss.currentAttack?.id === 'knightWallCharge')))
  if (reFaceNow) {
    next = { ...next, facing: turnTowardPlayer(next, player) }
  }

  // 主人公が崩れたら、今振っている拍も打ち切って致命へ (src/stun_cut.ts・既定・旧は DEV ?stunCut=0)。
  //   当たり・連撃の間・拍の間 → その技の戻りを早回しで / 戻りの途中 → 残りを早回しで / 溜め → 下の telegraph でその場で致命の溜めへ。
  if (stunCutOn() && boss.state !== 'staggered' && execStunActive(player, next.id)) {
    const atk = boss.currentAttack
    if (atk && !atk.bossFinisher && !atk.playerLethal) {
      const beat = boss.currentString?.beats[boss.beatIndex]
      const recMs = beat?.recoveryOverrideMs ?? atk.recoveryMs
      if ((atk.choreography === 'awokenRampageV5' || isWallHuntGame(boss)) && boss.state === 'active') {
        // 覚醒王の大暴れ・壁走り: 宙 (壁・跳び) にいることがあるので戻りへは入らず、その場から致命へ (宙なら溜めの頭で床へ降りる)。
        const finisher = getBossFinisherFor(next, player, bounds)
        if (finisher) {
          const alt = next.altitudePx ?? 0
          const { choreo: _c, ...rest } = next
          return enterState({ ...rest, facing: player.x < next.x ? 'left' : 'right' }, 'telegraph', {
            currentAttack: finisher, currentString: null, beatIndex: 0, behindMs: 0, actionAnchorX: next.x,
            attackCount: boss.attackCount + 1, ...(alt > 0 ? { finisherDropFromPx: alt } : {}),
          })
        }
      } else if (stunCutDirect(next.id) && !(next.altitudePx && next.altitudePx > 0) && !boss.cutRecovery
        && (boss.state === 'active' || boss.state === 'comboGap' || boss.state === 'beatGap' || boss.state === 'recovery')) {
        // 覚醒王 (10-12 F-2・src/stun_cut.ts directByBoss): 構え直しを挟まず、今の姿から致命の溜め (後ろ跳びの屈み) へ。
        //   後ろ跳びを前の拍の速さへ戻した分の時間をここで取り返す (崩れてから当たるまで 1.8 秒以内)。
        const finisher = getBossFinisherFor(next, player, bounds)
        if (finisher) {
          return enterState({ ...next, facing: player.x < next.x ? 'left' : 'right' }, 'telegraph', {
            currentAttack: finisher, currentString: null, beatIndex: 0, behindMs: 0, actionAnchorX: next.x,
            attackCount: boss.attackCount + 1,
          })
        }
      } else if (boss.state === 'active' && !boss.cutRecovery && !stunCutStopsInPlace(atk, boss)) {
        // 普通の振り: 振りの残り (当たった後の振り抜き) と戻りを、同じ倍率で早回しして待機の絵まで戻す
        //   (振りの絵の並びと踏み込みを飛ばさない = 戻りの絵がずれた所に出ない・介錯の据えの振りで 1 コマに足が 74px 跳んでいた)。
        //   振りの残りは速くしすぎない (stunCutActiveRateMax・振りの中の絵の動きを詰めすぎると 1 コマに大きく動く)。戻りで残りの時間を詰める。
        const left = Math.max(0, atk.activeMs - boss.stateElapsed * 1000)
        const rate = Math.min(stunCutActiveRateMax(next.id), stunCutRate(left + recMs, next.id))
        // 戻り: 既定 (10-12 F-1) は戻りの絵を1枚ずつ等速で少し見せて致命へ (recPoseHold → cutPoseHoldMs)。DEV ?stunCutLook=warp は前の早回し (recRate)。
        const cutRec = stunCutWarpsRecovery()
          ? { rate, fromActive: false, recRate: Math.max(1, recMs / Math.max(1, stunCutBridgeMs(next.id) - left / rate)) }
          : { rate, fromActive: false, recRate: 1, recPoseHold: true }
        next = { ...next, cutRecovery: cutRec, stateElapsed: boss.stateElapsed + FIXED_DT * rate }
      } else if ((boss.state === 'active' && !boss.cutRecovery) || boss.state === 'comboGap' || boss.state === 'beatGap') {
        // 走り抜け・長い突進 (当たりが長い技) と、連撃・連の拍の間: その場で戻りへ (走りを早回しすると 1 コマに大きく跳ぶ)。
        return enterState(next, 'recovery', {
          recoveryRecenterMovedPx: 0, behindMs: 0,
          cutRecovery: stunCutWarpsRecovery()
            ? { rate: stunCutRate(recMs, next.id), fromActive: boss.state === 'active' }
            : { rate: 1, fromActive: boss.state === 'active', holdUntilMs: cutPoseHoldMs(next, atk, recMs) },
        })
      } else if (boss.state === 'recovery' && !boss.cutRecovery) {
        if (stunCutWarpsRecovery()) {
          const rate = stunCutRate(recMs - boss.stateElapsed * 1000, next.id)
          next = { ...next, cutRecovery: { rate, fromActive: false }, stateElapsed: boss.stateElapsed + FIXED_DT * rate }
        } else {
          next = { ...next, cutRecovery: { rate: 1, fromActive: false, holdUntilMs: boss.stateElapsed * 1000 + cutPoseHoldMs(next, atk, recMs) } }
        }
      }
    }
  }

  const elapsedMs = next.stateElapsed * 1000
  let enteredActive = false

  if (boss.state === 'staggered') {
    if (elapsedMs >= BOSS.staggerMs) {
      next.state = 'idle'
      next.stateElapsed = 0
      next.posture = 0
      next.currentString = null
      next.beatIndex = 0
      next.riseHoldMs = bossRiseHoldMs(next.id)
    }
    return { boss: next, enteredActive }
  }

  switch (boss.state) {
    case 'idle': {
      // 崩れから立ち上がる間は動かない・技も出さない (src/boss_rise.ts・絵のあるボスだけ)。
      if ((next.riseHoldMs ?? 0) > 0) {
        next.riseHoldMs = Math.max(0, next.riseHoldMs! - FIXED_DT * 1000)
        return { boss: next, enteredActive }
      }
      if (next.exec) {
        next = {
          ...next,
          exec: {
            ...next.exec,
            backstepCooldownMs: Math.max(0, next.exec.backstepCooldownMs - FIXED_DT * 1000),
            // 🔵 2026-09-04: 砲身薙ぎの冷却も idle でだけ減る (攻撃中は減らない = 次の idle で必ず後退が先に立つ)。
            sweepCooldownMs: Math.max(0, (next.exec.sweepCooldownMs ?? 0) - FIXED_DT * 1000),
          },
        }
      }
      // 崩れを見たら、まだ始まっていない組み変わり (介錯) より致命を先に出す (src/stun_cut.ts・既定・旧は DEV ?stunCut=0)。
      //   組み変わりの予約は残る (致命の後の待機で組み変わる)。始まった組み変わりは止めない (下の節で最後まで出す)。
      if (stunCutOn() && player.state === 'stunned'
        && !(next.exec?.morph === 'morphing' && next.exec.morphElapsedMs > 0)) {
        const finisher = getBossFinisherFor(next, player, bounds)
        if (finisher) {
          return enterState(next, 'telegraph', {
            currentAttack: finisher, attackCount: boss.attackCount + 1, currentString: null, beatIndex: 0, behindMs: 0,
            actionAnchorX: next.x,
          })
        }
      }
      // 剣舞のアルレ版の拍手 (10-29 配布版の既定・src/blade_dancer_clap.ts): 拍手の間は攻めも歩きもしない (攻撃判定なし)。
      const clapping = tickBladeClap(next, FIXED_DT * 1000)
      if (clapping) return { boss: clapping, enteredActive }
      // 請われぬ介錯: 変形は攻撃終了後に予約され、idle を1つの見えるアクションとして占有する。
      // 被弾・体幹には無敵や倍率特例を入れず、攻撃選択だけをこの間止める。
      if (next.exec?.morph === 'morphing') {
        // 🔵 2026-10-02 (通しパック P-2 → A): 自分の榴弾が落ち切るまで、組み変わりを始めずにその場で待つ。
        //   始まった組み変わりは止めない (morphElapsedMs > 0 は素通し)。
        if (next.exec.morphElapsedMs === 0 && (next.exec.hazardPendingMs ?? 0) > 0) {
          return { boss: next, enteredActive }
        }
        let morphExec = { ...next.exec, step: null }
        const morphStepMs = FIXED_DT * 1000
        if (morphExec.morphTurnRequired === null) {
          const targetFacing = player.x < next.x ? 'left' : 'right'
          const needsTurn = Math.abs(player.x - next.x) > FACING_FLIP_DEADBAND_PX
            && boss.facing !== targetFacing
          morphExec = { ...morphExec, morphTurnRequired: needsTurn }
        }
        const timing = executionerMorphTiming(morphExec)
        const nextMorphElapsedMs = morphExec.morphElapsedMs + morphStepMs
        const contactsNow = morphExec.morphElapsedMs < timing.shoveHitAtMs
          && nextMorphElapsedMs >= timing.shoveHitAtMs
        let pushedPlayer: Player | undefined
        if (contactsNow && Math.abs(player.x - next.x) <= EXECUTIONER.transform.shoveReachPx) {
          // hits.ts の knockbackPx 分岐と同じ設定だけを行う。移動・壁クランプ・減速は
          // updatePlayer の applyKnockbackDrift に既存どおり任せ、ダメージ/体幹/パリィ判定は作らない。
          const away = player.x >= next.x ? 1 : -1
          pushedPlayer = {
            ...player,
            knockbackRemainingPx: away * EXECUTIONER.transform.shovePushPx,
          }
        }
        // ボスの x は一切変更しない。壁際でも補正・追い討ち・後退・変形見送りを足さない。
        next = { ...next, exec: stepMorph(morphExec, morphStepMs) }
        return { boss: next, enteredActive, ...(pushedPlayer ? { player: pushedPlayer } : {}) }
      }

      // 2026-07-01: blinkCooldownMs は関数頭の常時減衰へ移動 (idle 制限を撤廃)。
      // 気絶中の敵を発見: 待機をスキップして固有フィニッシャー攻撃
      if (player.state === 'stunned') {
        const finisher = getBossFinisherFor(next, player, bounds)
        if (finisher) {
          return enterState(next, 'telegraph', {
            currentAttack: finisher,
            attackCount: boss.attackCount + 1,
            currentString: null,
            beatIndex: 0,
            behindMs: 0,
            actionAnchorX: next.x,  // 寄せ補間の起点を記録 (active 突入で上書きされるまで保持)
          })
        }
      }

      // 割り込み反撃 (combat-feel-v2 §4.1): 殴られ続けたら idle の待ちを打ち切って応手。
      //   telegraph はフル尺 = 読める出題。 recovery は中断しない (攻め時の教育を守る)。
      const retaliationId = getBossDefinitionById(next.id)?.retaliationAttackId
      if (retaliationId && retaliationEnabled
        // 致命後の静止 (combat.ts が stateElapsed を -1.1 秒から始める) の間は応手しない (2026-09-29 ユーザー
        //   「致命モーション終了直後の技が不可避」→ 抜け道をふさぐ)。通常の攻撃選択と同じ待ちに揃える。
        && elapsedMs >= 0
        && next.retaliationCooldownMs <= 0
        && next.recentHitAgesMs.length >= RETALIATION.hits
        // 覚醒王: 懐の相手へ届かない噛みでは応手しない (懐では噛まない・2026-09-26)。通常の抽選で突進などを選ぶ。
        && !awokenBiteInPocket(next, player, retaliationId)) {
        return enterState(next, 'telegraph', {
          currentAttack: getAttack(retaliationId),
          attackCount: boss.attackCount + 1,
          lastAttackId: retaliationId,
          lastAttackStreak: retaliationId === boss.lastAttackId ? boss.lastAttackStreak + 1 : 1,
          retaliationCooldownMs: RETALIATION.cooldownMs,
          recentHitAgesMs: [],
          currentString: null,
          beatIndex: 0,
          behindMs: 0,
        })
      }

      // 介錯の幕2の頭 (咆哮の新版の既定・旧は DEV ?roarAir=0・src/exec_roar_center.ts・2026-10-10 ユーザー「幕２にはいった時にボスが動画みたいに真ん中に移動すれば良さそう」):
      //   確定初手の咆哮の前に、部屋の真ん中へ移ってから吠える (間合いに入るのを待たない)。致命の後の静止の間は動かない。
      //   旧 (DEV ?roarAir=0 か &roarAirCenter=0) は roarCenterApplies が常に false = この節は素通り。
      {
        const centerDef = getBossDefinitionById(next.id)
        if (roarCenterApplies(next, centerDef?.roomEntryForcedAttacks)) {
          // 開発版 ?execAct2Open=blink: 歩かずに花嫁の宵渡りと同じ見せ方で真ん中へ移る (src/exec_act2_blink.ts)。
          const center = act2BlinkOn() ? stepAct2Blink(next, player, elapsedMs)
            : stepRoarCenter(next, player, elapsedMs, roarCenterWalkSpeed(centerDef?.walkSpeedMul))
          if (center.ready) {
            const atk = getAttack(ROAR_CENTER_ATTACK_ID)
            const { roarCenter: _rc, ...rest } = center.boss
            return enterState({ ...rest, exec: { ...rest.exec!, step: null } }, 'telegraph', {
              currentAttack: atk,
              currentString: null,
              beatIndex: 0,
              attackCount: boss.attackCount + 1,
              lastAttackId: atk.id,
              lastAttackStreak: 1,
              behindMs: 0,
              roomEntryForcedDone: [...(next.roomEntryForcedDone ?? []), next.executesTaken],   // ロック (再発動しない)
            })
          }
          return { boss: center.boss, enteredActive }
        }
      }

      // 生きたお見合い (2026-07-19): 攻撃後に抽選した「一手」を消化する区間。
      //   息継ぎ = その場で休む / 仕切り直し = 離れる。 この間は歩かない・攻撃しない・blink しない
      //   (= 一手を正直に演じ切る)。 press は長さ 0 なのでここは素通り = 現行挙動と完全一致。
      //   ★割り込み反撃 (retaliation) は上で先に判定済み = 「居座りすぎ」への反応は一手中も生きる。
      const standoffCfg = getBossDefinitionById(next.id)?.standoff
      if (inStandoffBeat(next, standoffCfg, elapsedMs)) {
        const vx = standoffResetVelocity(next, standoffCfg, player.x, elapsedMs)
        if (vx !== 0) {
          const x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, next.x + vx * FIXED_DT))
          next = { ...next, x }
        }
        return { boss: next, enteredActive: false }
      }

      // 宵渡り (blink): 解禁済 + クールダウン明けで、 時間変動の決定的ハッシュにより発動。
      //   攻撃 (AttackDef) ではなく state として持つ (無ダメ技に命中判定を混ぜない・Codex監査4)。
      const idleDef = getBossDefinitionById(next.id)
      // 部屋突入の確定初手が保留中なら blink を優先させない (2026-07-10 花嫁裾乱れ):
      //   「確定で初手を打つ」を厳密に満たす = 発動前に blink が割り込むと初手が遅延・希薄化する。
      //   確定初手が済めば (roomEntryForcedDone に room 追加) blink は通常通り復帰。
      const forcedOpenerPending = !!idleDef?.roomEntryForcedAttacks?.some(
        (e) => e.room === next.executesTaken && !(next.roomEntryForcedDone ?? []).includes(e.room))
      const blinkCfg = idleDef?.blink
      if (!forcedOpenerPending && blinkCfg
        && next.executesTaken >= blinkCfg.unlockAtExecutes
        && next.blinkCooldownMs <= 0
        && elapsedMs >= BLINK_MIN_IDLE_MS
        && hash01(next.attackCount * 7.7 + Math.floor(elapsedMs / 300) * 1.3) < 0.75) {
        // 2026-07-01: 閾値 0.45 → 0.75 (発動確率アップ)。 短い idle でも判定通るように。
        return enterState(next, 'blink', { currentAttack: null, currentString: null, beatIndex: 0 })
      }

      // ターゲットカメラ風: 間合いが遠ければ歩いて詰める。
      //   歩速/間合いはボス定義のオーバーライドを優先 (Task 16: 騎士=遅い儀礼歩行+槍の遠間)。
      const defTuning = getBossDefinitionById(next.id)
      // DEV ?lunaWalk=v2|v3|v4run|v4walk|v5|v6a|v6b|v6c|v7a|v7b (src/player_walk_new.ts) の時だけ、騎士と亡霊を下がる主人公 (160px/秒・v4walk と v5・v6 は 110・v7 は 130) に追いつける速さへ上げる。 配布版は null = 今のまま
      const walkSpeed = BOSS.walkSpeed * (lunaWalkBossWalkMul(next.id) ?? defTuning?.walkSpeedMul ?? 1)
      // 請われぬ介錯だけは形態別のペアで上書きする。他ボスは従来の定義→共通既定をそのまま通る。
      const execRange = next.exec ? rangeTuningFor(next.exec, next.executesTaken) : undefined
      const finaleRange = awokenFinaleRange(next)
      const preferredRange = finaleRange?.preferredRange ?? execRange?.preferredRange ?? defTuning?.preferredRange ?? BOSS.preferredRange
      const commitRange = finaleRange?.attackCommitRange ?? execRange?.attackCommitRange ?? defTuning?.attackCommitRange ?? BOSS.attackCommitRange
      const dist = Math.abs(next.x - player.x)
      if (usesKnightSpearSpacing(next)) {
        next = { ...next, knightInsideIdleMs: dist < KNIGHT_RETREAT_TRIGGER_PX
          ? (boss.knightInsideIdleMs ?? 0) + FIXED_DT * 1000 : 0,
          knightPostAttackHoldMs: Math.max(0, (boss.knightPostAttackHoldMs ?? 0) - FIXED_DT * 1000),
          knightCloseConsidered: dist < KNIGHT_RETREAT_TRIGGER_PX && (boss.knightPostAttackHoldMs ?? 0) <= FIXED_DT * 1000
            ? boss.knightCloseConsidered : false }
      }
      if (next.regainActive && dist >= preferredRange - BOSS.neutralBackOffHysteresisPx) {
        next = { ...next, regainActive: false, regainDeferredMs: 0 }
      }
      // 立て直し中は攻撃を最大 deferMs だけ後回しにする (0 = しない)。確定初手・フェーズ移行は例外。
      const regainAllowsAttack = !next.regainActive || (next.regainDeferredMs ?? 0) > overlapRegain.deferMs
      let neutralAllowsAttack = true
      // 覚醒王の間合いの一手 (09-27 採用): 届くか・一手が終わったかで攻撃に入る。他ボス・DEV `?spacing=old` では undefined のまま。
      let spacingAllowsAttack: boolean | undefined
      if (next.exec) {
        const tickMs = FIXED_DT * 1000
        let exec = next.exec
        // 🔵 2026-09-03 第4便: 砲の間合い関連の数値は全部ここから読む (EXECUTIONER.keepDistance/ranges.cannon は参照禁止)。
        const cannonTuning = cannonRangeTuning()
        const activeStep = exec.step
        if (activeStep) {
          const toward = activeStep.kind === 'forward'
            ? activeStep.direction
            : player.x < next.x ? -1 : 1
          const desiredX = player.x - toward * preferredRange
          const advanced = advanceExecutionerStep(
            activeStep, next.x, desiredX - next.x, tickMs, EXECUTIONER.step, walkSpeed,
            getExecutionerStepStyle(),
          )
          let x = advanced.x
          if (activeStep.kind === 'forward') {
            const dir = activeStep.direction
            x = clampToBossCoreFront(x, next.x, player.x, dir, null, next)
          }
          x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, x))
          const landedInCommitRange = activeStep.kind === 'forward'
            && activeStep.phase === 'travel'
            && advanced.step?.phase === 'land'
            && Math.abs(x - player.x) <= commitRange
          const advancedStep = landedInCommitRange && advanced.step
            ? { ...advanced.step, commitOnLand: true }
            : advanced.step
          if (activeStep.kind === 'back' && advanced.step === null) {
            exec = {
              ...exec,
              backstepCooldownMs: EXECUTIONER.step.back.cooldownMs,
              consecutiveKeepDistanceRetreats: exec.held === 'cannon'
                ? Math.min(
                  cannonTuning.maxConsecutive,
                  exec.consecutiveKeepDistanceRetreats + 1,
                )
                : exec.consecutiveKeepDistanceRetreats,
            }
          }
          next = { ...next, x, exec: { ...exec, step: advancedStep } }
        } else if (exec.held === 'cannon' && dist < cannonTuning.tooClosePx
          // 🔵 2026-09-03 第4便: 密着 (sweepWithinPx 以内) は後退より砲身薙ぎ (exec_cannonSweep) を優先する
          //   (下の idle 末尾の強制選択)。ここで後退させると密着へのお仕置きが選ばれる前に離脱してしまう。
          // 🔵 2026-09-04: ただし薙ぎの冷却中 (sweepCooldownMs > 0) は密着でも後退が先＝薙ぎは連発しない。
          && (dist > cannonTuning.sweepWithinPx || (exec.sweepCooldownMs ?? 0) > 0)) {
          const away = player.x < next.x ? 1 : -1
          const wallRoomPx = away > 0 ? bounds.rightWall - next.x : next.x - bounds.leftWall
          // 壁際の分岐 (§3 案A・2026-08-29): 後退の門は開いている (cooldown明け・連続上限未満)
          //   のに壁が近くて下がれない、という状況だけをすれ違いへ回す。門自体が閉じている
          //   (cooldown中・連続上限後) 時はすれ違いも出さず、至近で撃つ既存挙動のまま。
          const gateOpen = getBossBackStep()
            && exec.backstepCooldownMs <= 0
            && exec.consecutiveKeepDistanceRetreats < cannonTuning.maxConsecutive
          const canRetreat = gateOpen && wallRoomPx >= cannonTuning.minWallRoomPx
          if (canRetreat) {
            const retreatPx = Math.min(
              cannonTuning.maxRetreatPx,
              cannonTuning.retreatToPx - dist,
              wallRoomPx,
            )
            const toX = next.x + away * retreatPx
            const backstep: ExecutionerStepState = {
              kind: 'back',
              style: getExecutionerStepStyle(),
              phase: 'travel',
              elapsedMs: 0,
              fromX: next.x,
              toX,
              settleMs: 0,
              direction: away,
              commitOnLand: false,
            }
            const advanced = advanceExecutionerStep(
              backstep, next.x, toX - next.x, tickMs, EXECUTIONER.step, walkSpeed,
              getExecutionerStepStyle(),
            )
            const x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, advanced.x))
            next = { ...next, x, exec: { ...exec, step: advanced.step } }
          } else if (gateOpen) {
            // 壁際 (§3 案A・2026-08-29 ユーザー承認): 下がれないならプレイヤーの反対側へ
            //   すれ違い、広い側で距離を取り直す。既存のステップ v2 (kind:'back') をそのまま
            //   再利用する＝新しい移動方式・新しい絵は無い。着地後のカウンタ加算・cooldownは
            //   下の「activeStep.kind === 'back' && advanced.step === null」節が汎用的に処理する
            //   ＝後退と同じカウンタをすれ違いも共有する。
            const sideDir = (away > 0 ? -1 : 1) as 1 | -1
            const sideTargetX = executionerSidestepTargetX(
              player.x, away, bounds, cannonTuning,
            )
            if (sideTargetX !== null) {
              const sidestep: ExecutionerStepState = {
                kind: 'back',
                style: getExecutionerStepStyle(),
                phase: 'travel',
                elapsedMs: 0,
                fromX: next.x,
                toX: sideTargetX,
                settleMs: 0,
                direction: sideDir,
                commitOnLand: false,
              }
              const advanced = advanceExecutionerStep(
                sidestep, next.x, sideTargetX - next.x, tickMs, EXECUTIONER.step, walkSpeed,
                getExecutionerStepStyle(),
              )
              const x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, advanced.x))
              next = { ...next, x, exec: { ...exec, step: advanced.step } }
            } else {
              // クランプ後もプレイヤーに近すぎる = すれ違う先が無い。現状どおり留まって至近で攻撃する。
              next = { ...next, exec }
            }
          } else {
            // 連続上限後・cooldown中は、回数を戻さず至近で攻撃する。
            next = { ...next, exec }
          }
        } else if (dist > preferredRange) {
          const dir = player.x < next.x ? -1 : 1
          const desiredX = player.x - dir * preferredRange
          const advanced = advanceExecutionerStep(
            null, next.x, desiredX - next.x, tickMs, EXECUTIONER.step, walkSpeed,
            getExecutionerStepStyle(),
          )
          let x = clampToBossCoreFront(advanced.x, next.x, player.x, dir, null, next)
          x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, x))
          next = { ...next, x, exec: { ...exec, step: advanced.step } }
        } else if (next.regainActive && overlapRegain.execStyle === 'walk'
          && dist < preferredRange - BOSS.neutralBackOffHysteresisPx
          && !(exec.held === 'cannon' && dist <= cannonTuning.sweepWithinPx && (exec.sweepCooldownMs ?? 0) <= 0)) {
          // 立て直し・歩き (?execRegain=walk): 一歩ずつ跳ねて止まる代わりに、他ボスと同じ連続の後退。
          //   絵は sprites.ts が 4コマ歩きを逆再生する (isExecutionerRegainWalk)。
          const away = player.x < next.x ? 1 : -1
          let x = next.x + away * walkSpeed * overlapRegain.speedMul * FIXED_DT
          x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, x))
          next = { ...next, x, exec }
        } else if (getBossBackStep()
          && dist < preferredRange - BOSS.neutralBackOffHysteresisPx
          && (exec.backstepCooldownMs <= 0 || next.regainActive)
          // 🔵 2026-09-03 第4便: 砲で密着 (sweepWithinPx 以内) されている時は、この汎用の小さな後退 (56px) も出さず
          //   砲身薙ぎ (exec_cannonSweep・下の攻撃選択) へ落とす。後退→薙ぎの二段になると「怯んでから振る」に読める。
          && !(exec.held === 'cannon' && dist <= cannonTuning.sweepWithinPx && (exec.sweepCooldownMs ?? 0) <= 0)) {
          const away = player.x < next.x ? 1 : -1
          // leap (?execRegain=leap): 立て直し中は好みの間合いまで一度で跳ぶ (56px を刻まない)。
          const backPx = next.regainActive && overlapRegain.execStyle === 'leap'
            ? Math.min(REGAIN_LEAP_MAX_PX, Math.max(EXECUTIONER.step.back.px, preferredRange - dist))
            : EXECUTIONER.step.back.px
          const toX = Math.max(
            bounds.leftWall,
            Math.min(bounds.rightWall, next.x + away * backPx),
          )
          if (Math.abs(toX - next.x) >= EXECUTIONER.step.back.minMovePx) {
            const backstep: ExecutionerStepState = {
              kind: 'back',
              style: getExecutionerStepStyle(),
              phase: 'travel',
              elapsedMs: 0,
              fromX: next.x,
              toX,
              settleMs: 0,
              direction: toX < next.x ? -1 : 1,
              commitOnLand: false,
            }
            const advanced = advanceExecutionerStep(
              backstep, next.x, toX - next.x, tickMs, EXECUTIONER.step, walkSpeed,
              getExecutionerStepStyle(),
            )
            const x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, advanced.x))
            next = { ...next, x, exec: { ...exec, step: advanced.step } }
          } else {
            next = { ...next, exec }
          }
        } else {
          next = { ...next, exec }
        }
      } else if (bladeBackStepLockOwns(next, dist < preferredRange - BOSS.neutralBackOffHysteresisPx)
        && (next.bladeBackStep !== undefined || !bladeBackStepSettled(next) || dist <= commitRange + BLADE_BACK_STEP_COMMIT_BONUS_PX)) {
        // 剣舞の後ろへ下がる所の比較版 (DEV ?bladeBackStep=lock・src/blade_back_step.ts): 足を床に留めた1歩 (約 151px) で下がり、
        //   下がった後は次の技まで詰める歩きをしない。配布版では通らない。
        const stepped = advanceBladeBackStep(next, player.x, dist < preferredRange - BOSS.neutralBackOffHysteresisPx, bounds, FIXED_DT * 1000)
        next = stepped.boss
        if (stepped.blocksAttack) neutralAllowsAttack = false
      } else if (!usesAwokenSpacingChoice(next) && usesSpacingChoice(next)) {
        // 戴冠獣・亡霊・花嫁 (11-01 配布版・前の動きは DEV `?spacingAll=old`・src/spacing_all.ts): 覚醒王の一手を当てる。
        //   技の選び方は変えず、攻撃に入る距離は今の commitRange。体の芯に重なった時は「近」の線まで歩いて下がる。
        const inCore = Math.abs(next.x - player.x) < bossCoreHalfWidth(next) + BOSS_CORE.playerHalfWidth
        const retreatTo = spacingAllTuning(next.id)?.nearPx
        const spacingFrom = next
        const spaced = updateAwokenSpacing(next, player, {
          walkSpeed,
          gapMs: attackGapMsFor(defTuning, boss.attackCount, boss.executesTaken, rampageV5TempoFromExecutes(next.id)),
          reachPx: commitRange,
          forced: forcedOpenerPending,
          retreatToPx: forcedOpenerPending || !inCore ? undefined : retreatTo,
          clampWalk: (x, fromX, dir) => clampToBossCoreFront(x, fromX, player.x, dir, null, spacingFrom),
        })
        next = spaced.boss
        spacingAllowsAttack = spaced.allowAttack
      } else if (usesAwokenSpacingChoice(next)) {
        // 覚醒王 (09-27 採用・旧は DEV `?spacing=old`): 追従の歩き・立て直しの後退の代わりに、区切りのある一手 (待つ／後ろ跳び／歩いて詰める)。
        //   攻撃に入れる距離は、今出せる連 (解禁・初登場の保証を通した候補) の中で一番遠くから出せるもの。
        const strings = debugBypassStrings ? undefined : defTuning?.strings
        const solo = debugSoloStringId ? strings?.find((s) => s.id === debugSoloStringId && s.blinkOnly !== true) : undefined
        const pool = solo ? [solo] : strings && strings.length > 0
          ? stringCandidates(next, player, rampageV5Strings(next, awokenFinaleStrings(next, player, strings)))
          : []
        const reachPx = forcedOpenerPending || pool.length === 0 ? commitRange : spacingReachPx(pool)
        // 懐では噛まない (2026-09-26): 出せる連が懐で届かない噛みだけなら、歩いて下がる一手にする。
        //   この動きには旧の「芯に居続けたら下がる立て直し」が無い (一手に置き換えた) ので、主人公が体の芯の中
        //   (芯半幅+主人公半幅) にいる時も同じ歩きで下がる。これが無いと、体に重なったまま突進・壁跳ねを出し
        //   (壁跳ねは主人公の真上から跳び出す)、旧の動きより不利な形になる (bot 回帰 seed 3 で確認)。
        const inCore = Math.abs(next.x - player.x) < bossCoreHalfWidth(next) + BOSS_CORE.playerHalfWidth
        const retreatToPx = forcedOpenerPending || solo ? undefined
          : awokenPocketRetreatTarget(next, player, strings, preferredRange, inCore)
        const spacingFrom = next
        const spaced = updateAwokenSpacing(next, player, {
          walkSpeed,
          gapMs: attackGapMsFor(defTuning, boss.attackCount, boss.executesTaken, rampageV5TempoFromExecutes(next.id)),
          reachPx,
          forced: forcedOpenerPending,
          retreatToPx,
          // 顔を見せる間合い (DEV ?awokenFaceRoom=1): 下がっても今出せる連が届く所まで。
          faceRoomPx: forcedOpenerPending || solo ? undefined : faceRoomFor(reachPx),
          clampWalk: (x, fromX, dir) => clampToBossCoreFront(x, fromX, player.x, dir, null, spacingFrom),
        })
        next = spaced.boss
        spacingAllowsAttack = spaced.allowAttack
      } else if (usesNeutralMovementTrial(next)) {
        if (!forcedOpenerPending) {
          const movement = updateNeutralMovement(next, player, commitRange, walkSpeed,
            attackGapMsFor(defTuning, boss.attackCount, boss.executesTaken, rampageV5TempoFromExecutes(next.id)))
          next = movement.boss
          neutralAllowsAttack = movement.allowAttack
        }
      } else if (usesKnightGait(next)) {
        // 騎士 (2026-09-27・src/knight_gait.ts): 近づく歩き・立て直しの後退を、絵の歩幅に合わせた足運びで行う。
        //   近づく条件・下がる条件 (好みの間合い・ヒステリシス・立て直し) は下の従来の2分岐と同じ。
        //   踏みしめ歩き (既定) は絵の足が床の同じ点に着く1歩 (74px) か半歩 (35px) 単位で、好みの間合いの手前 10px より
        //   深くは踏み込まない。後退は歩く速さの 1.5 倍 (旧は立て直しの 2倍速の立ち絵滑り)。
        const toward: 1 | -1 = player.x < next.x ? -1 : 1
        const spearSpacing = usesKnightSpearSpacing(next)
        const roomBehind = knightRoomBehind(next.x, player.x)
        // 致命後の静止 (stateElapsed < 0) の間は壁ぎわ突進・跳び下がり薙ぎも出さない (2026-09-29・応手と同じ)。
        const holding = spearSpacing && (next.knightPostAttackHoldMs ?? 0) > 0
        const postExecuteHold = elapsedMs < 0
        const leapOnly = getKnightBackoff() === 'leap'
        // 'mix' (既定・09-29 午後): 歩いて下がらず、近さだけで跳び下がり薙ぎも出さない (薙ぎの抽選で混ぜる・下の攻撃選択)。
        const mix = getKnightBackoff() === 'mix'
        const noWalkBack = leapOnly || mix
        const close = dist < KNIGHT_RETREAT_TRIGGER_PX
        const wallCross = spearSpacing && !holding && !postExecuteHold && roomBehind < KNIGHT_CROSS_WALL_ROOM_PX && dist < 110
        // Chased: the player kept pace with the retreat for KNIGHT_CROSS_PURSUIT_MS (2026-09-28 pack 09-28b
        // playlog: a pressing player drove the knight wall to wall and the cut was never rolled again).
        const pursued = spearSpacing && !holding && close && !!next.knightRetreating
          && (next.knightInsideIdleMs ?? 0) >= KNIGHT_CROSS_PURSUIT_MS
        const backwardOpportunity = spearSpacing && !mix && !holding && !postExecuteHold && roomBehind >= KNIGHT_CROSS_WALL_ROOM_PX
          && close && (leapOnly || (!next.knightRetreating && !next.knightCloseConsidered) || pursued)
        const crossString = defTuning?.strings?.find((s) => s.id === 'knight-threshold-cross')
        const crossRoomOpen = crossString && (crossString.unlockAtExecutes ?? 0) <= next.executesTaken
          && (crossString.maxExecutes == null || next.executesTaken <= crossString.maxExecutes)
        // 部屋の解禁: 壁ぎわ突進は1部屋目から (?knightWallCross=late で2部屋目から)。跳び下がり薙ぎは
        //   leapOnly (既定) なら1部屋目から、walk (09-28 版) なら連の解禁 (2部屋目) から。
        const crossRoomAllows = wallCross ? (crossRoomOpen || getKnightWallChargeEarly()) : (leapOnly || crossRoomOpen)
        const crossUnlocked = !debugBypassStrings && (next.lastCrossArenaAttackCount === undefined
          || next.attackCount - next.lastCrossArenaAttackCount >= CROSS_ARENA_LOCKOUT_ATTACKS)
          && crossRoomAllows ? crossString : undefined
        const crossRoll = backwardOpportunity && crossUnlocked && !leapOnly && (next.knightRetreatRecentMs ?? 0) <= 0
          ? Math.random() : 1
        // 位置関係のマンネリ ('mix'・ユーザーの選択「騎士が動いていない時間」): 騎士が 150px の幅に 10 秒いたら、
        //   次の攻撃 (攻撃の間隔が明けた時) を壁ぎわ突進にする。主人公の向こうに走り抜ける床が 300px 以上ある時だけ。
        //   部屋の解禁・3回のロックアウトは壁ぎわの突進と同じ。
        const staleCharge = spearSpacing && mix && getKnightStaleCharge() && !wallCross && !holding && !postExecuteHold
          && (next.knightStaleMs ?? 0) >= KNIGHT_STALE_MS
          && knightChargeRoomPastPlayer(next.x, player.x) >= getKnightStaleRunRoom()
          && elapsedMs >= attackGapMsFor(defTuning, boss.attackCount, boss.executesTaken, rampageV5TempoFromExecutes(next.id))
          && !!crossString && !!(crossRoomOpen || getKnightWallChargeEarly()) && !debugBypassStrings
          && (next.lastCrossArenaAttackCount === undefined
            || next.attackCount - next.lastCrossArenaAttackCount >= CROSS_ARENA_LOCKOUT_ATTACKS)
        const charge = wallCross || staleCharge
        if (staleCharge || ((wallCross || backwardOpportunity) && crossUnlocked
          && (wallCross || leapOnly || pursued || (next.knightRetreatRecentMs ?? 0) > 0 || crossRoll < 0.4))) {
          const cross = crossString!
          const atk = getAttack(charge ? 'knightWallCharge' : cross.beats[0]!.attackId)
          return enterState({ ...next, knightCloseConsidered: true }, 'telegraph', {
            currentAttack: atk, currentString: charge ? null : cross, beatIndex: 0,
            lastStringId: cross.id, attackCount: boss.attackCount + 1,
            lastAttackId: atk.id, lastAttackStreak: 1, behindMs: 0,
            facing: player.x < next.x ? 'left' : 'right',
            knightCrossRetreatCapPx: charge ? undefined : knightCrossRetreatCap(next.x, player.x),
            knightLeapTotalPx: charge ? undefined : Math.max(0, Math.min(180, roomBehind)),
            lastCrossArenaAttackCount: boss.attackCount + 1,
            knightCloseStreak: 0,
          })
        }
        // leapOnly (既定) では歩いて下がらない＝近すぎる時の後退も、攻撃後の静かな戻りもしない。
        const spearRetreat = spearSpacing && !noWalkBack && !holding && roomBehind >= KNIGHT_CROSS_WALL_ROOM_PX
          && (next.knightRetreating ? dist < KNIGHT_RETREAT_TARGET_PX : dist < KNIGHT_RETREAT_TRIGGER_PX)
        // Only a completed spear attack earns this calm re-spacing. Player pressure below 80px
        // still goes through the cut/retreat choice above, not this post-attack gait.
        const respaceState = next.knightPostAttackRespace
        const postAttackRespace = spearSpacing && !noWalkBack && !holding && !close && roomBehind >= KNIGHT_CROSS_WALL_ROOM_PX
          && (respaceState === 'active' ? dist < KNIGHT_RETREAT_TARGET_PX
            : respaceState === 'pending' && dist < KNIGHT_POST_ATTACK_RESPACE_TRIGGER_PX)
        // A planted step takes time; hold the recovered distance briefly so short room-3 gaps
        // do not turn the entire idle window into the retreat itself.
        // Let the planted stance read as spear distance before the next attack. The 900ms
        // pause also keeps the 600ms punish hold from dominating the stationary idle range.
        const knightRetreatHoldMs = spearRetreat || postAttackRespace ? 0
          : next.knightRetreating ? 450
            : respaceState === 'active' && !close ? 900
              : Math.max(0, (next.knightRetreatHoldMs ?? 0) - FIXED_DT * 1000)
        next = { ...next, knightRetreating: spearRetreat, knightRetreatHoldMs,
          knightPostAttackRespace: holding ? (close ? undefined : respaceState)
            : postAttackRespace ? 'active' : undefined,
          knightCloseConsidered: close && !holding ? true : next.knightCloseConsidered,
          knightRetreatRecentMs: spearRetreat && !boss.knightRetreating ? 2500 : next.knightRetreatRecentMs }
        const backOff = spearRetreat || postAttackRespace || ((!spearSpacing && next.regainActive || (isBossNeutralBackOff() && getBossBackStep()))
          && dist < preferredRange - BOSS.neutralBackOffHysteresisPx)
        let want: KnightGaitWant | null = null
        if (!holding && dist > preferredRange) {
          want = { worldDir: toward, backward: false, remainingPx: dist - preferredRange,
            mustPx: dist - commitRange, speed: walkSpeed }
        } else if (!holding && backOff) {
          want = { worldDir: (-toward) as 1 | -1, backward: true,
            remainingPx: (spearRetreat || postAttackRespace ? KNIGHT_RETREAT_TARGET_PX : preferredRange - BOSS.neutralBackOffHysteresisPx) - dist,
            mustPx: 0, speed: walkSpeed }
        }
        const gait = advanceKnightGait(next, want)
        const moveDir: 1 | -1 = gait.x >= next.x ? 1 : -1
        let x = gait.x
        // 歩きでも主人公を追い越さない (2026-07-27) = 近づく1歩だけ芯の手前で止める。
        if (moveDir === toward) x = clampToBossCoreFront(x, next.x, player.x, toward, null, next)
        x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, x))
        // A clipped snap would move a held bitmap by less than its foot-lock distance.
        // Cancel the whole change and keep the previous stance until a full step fits.
        const snapClipped = getKnightMove() === 'snap' && Math.abs(x - gait.x) > 0.01
        if (snapClipped) x = next.x
        next = { ...next, x, knightGait: snapClipped ? next.knightGait : settleKnightGait(next, gait.gait, x, gait.x) }
        if (gait.blocksAttack && !snapClipped && (getKnightMove() === 'step' || getKnightMove() === 'snap')) neutralAllowsAttack = false
        if (spearRetreat || postAttackRespace || knightRetreatHoldMs > 0 || holding) neutralAllowsAttack = false
      } else if (usesRoosterHopMove(next)) {
        // 鶏の跳ね (DEV ?roosterMove=hop・src/rooster_hop_move.ts): 下の「遠ければ歩いて詰める」「近すぎれば下がる」を跳ねに替え、時々主人公を跳び越える。
        const hopped = updateRoosterHopMove(next, player, {
          preferredRange,
          wantsBack: (next.regainActive || (isBossNeutralBackOff() && getBossBackStep())) === true
            && dist < preferredRange - BOSS.neutralBackOffHysteresisPx,
          bounds, dtMs: FIXED_DT * 1000,
        })
        next = hopped.boss
        neutralAllowsAttack = hopped.allowAttack
      } else if (dist > preferredRange) {
        const dir = player.x < next.x ? -1 : 1
        let x = next.x + dir * walkSpeed * FIXED_DT
        // 歩きでも主人公を追い越さない (2026-07-27)。 攻撃と違い「大技だから突っ切る」理由が無い。
        x = clampToBossCoreFront(x, next.x, player.x, dir, null, next)
        x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, x))
        next = { ...next, x }
      } else if ((next.regainActive || (isBossNeutralBackOff() && getBossBackStep()))
        && dist < preferredRange - BOSS.neutralBackOffHysteresisPx) {
        // 🔴 距離のラチェットの本体はここ (2026-07-27)。 上の「遠ければ詰める」だけがあって
        //   「近すぎれば離れる」が無かったため、ボスは一方向にしか動かず、二人の距離は詰まる一方だった
        //   (友達FB「重なっている時間が長い」/ 実測で壁200px以内の滞在が 78.6%)。
        //   ヒステリシス = 好みの間合いちょうどでは動かない。 これが無いと毎tick前後に震える。
        //   09-26: 常時の0.7倍後退は DEV 比較だけ。通常起動では立て直し中だけこの分岐へ入る。
        const away = player.x < next.x ? 1 : -1
        // 立て直し中 (BOSS.overlapRegain) だけ速く離れる = 歩いて押し込んでも追いつかれない。
        const backOffMul = next.regainActive ? overlapRegain.speedMul : BOSS.neutralBackOffSpeedMul
        let x = next.x + away * walkSpeed * backOffMul * FIXED_DT
        x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, x))
        next = { ...next, x }
      }
      // 攻撃に入るのは「間合いに入ってから」。 遠ければ溜めずに詰め続ける。
      //   → 遠距離から telegraph→空振りを繰り返す「下がり得」を構造的に消す。
      //   walkSpeed > プレイヤー後退 なので、 逃げ続けても必ず間合いに入って攻撃が来る
      //   (walkSpeedMul は最低でもプレイヤー後退 120px/s を上回る範囲で設定すること)。
      // 覚醒王 (旧の動き = DEV `?spacing=old` だけ・2026-09-26 ユーザー裁定「懐では噛まない」): 懐にいる相手へ出せる連が噛みだけなら、
      //   攻撃せずに歩いて下がり、口が届く間合いを取り直す (歩きの絵・0.7倍の常時後退 8e66b9e1 とは別の一手)。
      //   突進など噛み以外の連が出せるなら下がらずそれを選ぶ (stringCandidates が懐の噛みを外す)。
      //   一度下がり始めたら止まる間合い (toPx) まで離れ切る (途中で噛みが届く間合いを掠めても止まらない = 行ったり来たりしない)。
      let pocketBlocked = false
      if (spacingAllowsAttack === undefined && !forcedOpenerPending) {
        // 着いた (done) 後は止まる間合いを持ち越さない = 相手が歩いて詰めてきても追い払い続けず、次は抽選へ進む。
        const stored = next.pocketRetreat && !next.pocketRetreat.done ? next.pocketRetreat.toPx : undefined
        const toPx = stored ?? awokenPocketRetreatTarget(next, player, defTuning?.strings, preferredRange)
        if (toPx !== undefined && Math.abs(boss.x - player.x) < toPx) {
          const away = player.x < boss.x ? 1 : -1
          // この tick の他の移動 (立て直し・詰める歩き) は捨て、歩く速さで下がる一手だけにする。
          //   止まる間合いちょうどで止める (行き過ぎると「遠いので詰める」歩きが数px 立ち絵のまま戻る)。
          const step = Math.min(walkSpeed * FIXED_DT, toPx - Math.abs(boss.x - player.x))
          const x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, boss.x + away * step))
          // 壁で下がれない時は取り直しを諦める (噛みを選び、空振りで見せる)。
          if (x !== boss.x) {
            pocketBlocked = true
            const arrived = Math.abs(x - player.x) >= toPx - 1e-6
            next = { ...next, x, pocketRetreat: arrived ? { toPx, done: true } : { toPx } }
          }
        }
      }
      if (!pocketBlocked && next.pocketRetreat) { const { pocketRetreat: _r, ...rest } = next; next = rest }
      const inCommitRange = spacingAllowsAttack !== undefined ? spacingAllowsAttack
        : Math.abs(next.x - player.x) <= commitRange
        || (bladeBackStepSettled(next) && Math.abs(next.x - player.x) <= commitRange + BLADE_BACK_STEP_COMMIT_BONUS_PX)
        || (next.exec?.step?.kind === 'forward'
          && next.exec.step.phase === 'settle'
          && next.exec.step.commitOnLand)
      const ptId = defTuning?.phaseTransitionAttackId
      const ptThreshold = defTuning?.phaseTransitionHpThreshold
      const phaseTransitionPending = !!(ptId && ptThreshold != null
        && !next.phaseTransitionTriggered
        && next.hp <= next.maxHp * ptThreshold)
      const stepAllowsAttack = !next.exec
        || next.exec.step === null
        || next.exec.step.phase === 'settle'
        || phaseTransitionPending
        || forcedOpenerPending
      // 請われぬ介錯: 攻撃と攻撃の間だけ形態倍率で伸び縮みする (刃=間が空く / 砲=中立)。
      //   ⚠️ 予告 (chargeMs) には掛けない = 読みやすさは触らない (finalRoomTempoMul と同じ作法)。
      const gapMul = next.exec ? mulsFor(next.exec).gapMul : 1
      // C つづきから (src/exec_bait.ts・既定 fix・前の版は DEV ?execBait=off): 致命を弾かれたら、間合いの待ちを飛ばして崩した連をすぐやり直す。
      const encore = encoreArmed(next)
      if (!pocketBlocked && (!usesKnightSpearSpacing(next) || (next.knightPostAttackHoldMs ?? 0) <= 0 || encore)
        && elapsedMs >= (encore ? EXEC_BAIT_ENCORE_GAP_MS : attackGapMsFor(defTuning, boss.attackCount, boss.executesTaken, rampageV5TempoFromExecutes(next.id)) * gapMul) && inCommitRange && stepAllowsAttack
        && (neutralAllowsAttack || phaseTransitionPending || forcedOpenerPending || encore)
        // 鶏の跳ね (DEV): 宙では技に入らない (入ると高さが床へ飛ぶ)。
        && !roosterHopInAir(next.roosterHop)
        && (regainAllowsAttack || phaseTransitionPending || forcedOpenerPending || spacingAllowsAttack !== undefined || encore)) {
        // フェーズ移行 (2026-07-03 導入・処刑人 G11 用): HP がしきい値以下 + 未発動なら次の技を強制上書き。
        //   通常の攻撃選択より優先。 発動後は phaseTransitionTriggered=true でロック (戦闘 1 回に 1 度)。
        //   idle → telegraph 遷移の瞬間だけ判定 (telegraph 中の技は中断しない)。
        if (phaseTransitionPending && ptId) {
          const atk = getAttack(ptId)
          return enterState(next, 'telegraph', {
            currentAttack: atk,
            currentString: null,
            beatIndex: 0,
            attackCount: boss.attackCount + 1,
            lastAttackId: atk.id,
            lastAttackStreak: 1,
            behindMs: 0,
            phaseTransitionTriggered: true,   // ロック (再発動しない)
          })
        }
        // 部屋突入で確定初手 (2026-07-10 導入・花嫁「裾乱れ」用): phaseTransition の executesTaken駆動版。
        //   next.executesTaken が room に一致 + 未発動 (roomEntryForcedDone に room が無い) なら、
        //   次の攻撃を強制上書きする。 通常の string/attackPool 選択より優先。
        //   idle → telegraph 遷移の瞬間だけ判定 (phaseTransition と同型・1 room = 1 回だけロック)。
        const forcedEntry = defTuning?.roomEntryForcedAttacks?.find(
          (e) => e.room === next.executesTaken && !(next.roomEntryForcedDone ?? []).includes(e.room))
        if (forcedEntry) {
          const atk = getAttack(rampageV5EntryAttack(next.id, forcedEntry.attackId))
          return enterState(next, 'telegraph', {
            currentAttack: atk,
            currentString: null,
            beatIndex: 0,
            attackCount: boss.attackCount + 1,
            lastAttackId: atk.id,
            lastAttackStreak: 1,
            behindMs: 0,
            roomEntryForcedDone: [...(next.roomEntryForcedDone ?? []), forcedEntry.room],   // ロック (再発動しない)
          })
        }
        // 🔵 2026-09-03 第4便: 砲形態で密着 (sweepWithinPx) されていたら砲身薙ぎで返す（抽選より優先・譜面なし）。
        //   幕1 (executesTaken 0) は刃なので出ない。
        //   🔵 2026-09-04: 冷却中は強制しない (後退できなかった壁際なら通常の砲譜面＝至近で撃つ)。
        if (next.exec && next.exec.held === 'cannon' && next.executesTaken >= 1
            && (next.exec.sweepCooldownMs ?? 0) <= 0
            && Math.abs(next.x - player.x) <= cannonRangeTuning().sweepWithinPx) {
          const atk = getAttack('exec_cannonSweep')
          return enterState(next, 'telegraph', { currentAttack: atk, currentString: null, beatIndex: 0,
            attackCount: boss.attackCount + 1, lastAttackId: atk.id, lastAttackStreak: 1, behindMs: 0 })
        }
        // C つづきから (src/exec_bait.ts・既定 fix): 崩した連 (無ければ技) を頭から。強制の初手・砲身薙ぎより後・抽選より前。
        if (encore && next.stunEncore) {
          const enc = next.stunEncore
          const pool = defTuning?.strings ?? []
          const str = enc.stringId
            ? (rampageV5Strings(next, awokenFinaleStrings(next, player, pool)).find((s) => s.id === enc.stringId)
              ?? pool.find((s) => s.id === enc.stringId) ?? null)
            : null
          const atk = getAttack(str ? str.beats[0]!.attackId : enc.attackId)
          return enterState(next, 'telegraph', {
            currentAttack: atk, currentString: str, beatIndex: 0,
            ...(str ? { lastStringId: str.id } : {}),
            attackCount: boss.attackCount + 1, lastAttackId: atk.id, lastAttackStreak: 1, behindMs: 0,
            facing: player.x < next.x ? 'left' : 'right',
            stunEncore: undefined,
            ...(usesKnightSpearSpacing(next) && atk.id === 'lanceCross'
              ? { knightCrossRetreatCapPx: knightCrossRetreatCap(next.x, player.x),
                  knightLeapTotalPx: Math.max(0, Math.min(180, knightRoomBehind(next.x, player.x))) } : {}),
          })
        }
        // 戴冠獣の駆け抜け (10-11 から配布版の既定・DEV ?houndPassThrough=0 で切る・src/hound_pass_through.ts): 同じ向きに流れ続けた／主人公を壁へ押し込んだ時、
        //   くじで普段の技の代わりに主人公の脇を駆け抜ける。1幕に2回まで・前の駆け抜けから3手あける。
        const passReason = debugBypassStrings ? null : houndPassReason(next, player)
        if (passReason && Math.random() < houndPassOdds(passReason)) {
          const atk = getAttack(HOUND_PASS_ATTACK_ID)
          return enterState(next, 'telegraph', {
            currentAttack: atk, currentString: null, beatIndex: 0,
            attackCount: boss.attackCount + 1, lastAttackId: atk.id, lastAttackStreak: 1, behindMs: 0,
            facing: player.x < next.x ? 'left' : 'right',
            ...houndPassEntryPatch(next),
          })
        }
        const strings = debugBypassStrings ? undefined : defTuning?.strings
        if (strings && strings.length > 0) {
          let str = pickNextString(next, player, rampageV5Strings(next, awokenFinaleStrings(next, player, strings)))
          // 'mix' (09-29 ユーザー「切り下がりは薙ぎと似ていてタイミングをずらされる技」): 単発の薙ぎを選んだ時、主人公が
          //   KNIGHT_LEAP_MIX_RANGE_PX (200px) の内側にいれば、くじ (既定 1/3) で近い時の技に差し替える。2部屋目から・2回続けない。
          //   10-02 ユーザー選択「近い時の技に戻す」: 既定 'both' = 主人公が切り下がりの穂先の内側 (KNIGHT_CROSS_MIX_RANGE_PX) にいて
          //   背後に床があれば半々で切り下がり、それ以外は柄の押し返し。それまで (10-01 夜〜) 切り下がりは通常の戦闘で出ていなかった。
          //   10-02 ユーザー「同じ場所で単調な戦いになりすぎないバランス」: くじは単発の薙ぎにしか乗らないので、近くで
          //   KNIGHT_CLOSE_PITY_PICKS 回続けて選んで (その間に押し返し・切り下がり・壁ぎわ突進が無ければ)、次は何を引いても近い時の技にする。
          const knightMix = usesKnightSpearSpacing(next) && getKnightBackoff() === 'mix'
          const closeNow = Math.abs(next.x - player.x) <= KNIGHT_LEAP_MIX_RANGE_PX
          const shoveString = strings.find((s) => s.id === 'knight-threshold-shove')
          const closeUnlocked = !!shoveString && (shoveString.unlockAtExecutes ?? 0) <= next.executesTaken
          const pityDue = getKnightClosePity() > 0 && (next.knightCloseStreak ?? 0) >= getKnightClosePity()
          if (knightMix && (str.id === 'knight-ward-sweep' || pityDue)
            && (!debugSoloStringId || debugSoloStringId === 'knight-ward-sweep')
            && next.lastAttackId !== 'lanceCross' && next.lastAttackId !== 'lanceShove'
            && closeNow) {
            // 跳び下がる切り下がりだけ背後の床が要る。押し返しは騎士が下がらない。
            const crossFits = Math.abs(next.x - player.x) <= KNIGHT_CROSS_MIX_RANGE_PX
              && knightRoomBehind(next.x, player.x) >= KNIGHT_CROSS_WALL_ROOM_PX
            const answer = getKnightCloseAnswer()
            if (pityDue || Math.random() < getKnightLeapOdds()) {
              const id = answer === 'shove' ? 'knight-threshold-shove'
                : answer === 'cross' ? (crossFits ? 'knight-threshold-cross' : null)
                : (crossFits && Math.random() < 0.5 ? 'knight-threshold-cross' : 'knight-threshold-shove')
              const close = id ? strings.find((s) => s.id === id) : undefined
              if (close && (close.unlockAtExecutes ?? 0) <= next.executesTaken
                && (close.maxExecutes == null || next.executesTaken <= close.maxExecutes)) str = close
            }
          }
          const closeAnswered = str.id === 'knight-threshold-shove' || str.id === 'knight-threshold-cross'
          const knightCloseStreak = knightMix && closeUnlocked && closeNow && !closeAnswered
            ? (next.knightCloseStreak ?? 0) + 1 : 0
          const atk = getAttack(str.beats[0]!.attackId)
          // crossArena: telegraph 開始時にプレイヤー向きを固定 (中央向きではなくプレイヤーを向いて薙ぐ)。
          //   player.x が左 → facing:'left' / player.x が右 → facing:'right'。
          //   active の踏み出しと recovery の中央復帰は facing とは独立 (中央方向のまま)。
          const crossFacing: Partial<Boss> = atk.crossArena
            ? { facing: player.x < next.x ? 'left' : 'right' }
            : {}
          return enterState(next, 'telegraph', {
            currentAttack: atk,
            currentString: str,
            beatIndex: 0,
            lastStringId: str.id,   // G-3: 反復抑制のため直近の連を記録
            ...rampageV5DebutSeen(next, str.id),
            ...(knightMix ? { knightCloseStreak } : {}),
            attackCount: boss.attackCount + 1,
            lastAttackId: atk.id,
            lastAttackStreak: 1,
            behindMs: 0,
            ...crossFacing,
            ...(usesKnightSpearSpacing(next) && atk.id === 'lanceCross'
              ? { knightCrossRetreatCapPx: knightCrossRetreatCap(next.x, player.x),
                  knightLeapTotalPx: Math.max(0, Math.min(180, knightRoomBehind(next.x, player.x))) } : {}),
            // C-6: crossArena 技の発動 attackCount を記録 (ロックアウト計算用)。
            ...(atk.crossArena ? { lastCrossArenaAttackCount: boss.attackCount + 1 } : {}),
          })
        }
        const atk = pickNextAttack(boss, player, attackPool)
        const streak = atk.id === boss.lastAttackId ? boss.lastAttackStreak + 1 : 1
        return enterState(next, 'telegraph', {
          currentAttack: atk,
          attackCount: boss.attackCount + 1,
          lastAttackId: atk.id,
          lastAttackStreak: streak,
          behindMs: 0,
          ...(usesKnightSpearSpacing(next) && atk.id === 'lanceCross'
            ? { knightCrossRetreatCapPx: knightCrossRetreatCap(next.x, player.x),
                  knightLeapTotalPx: Math.max(0, Math.min(180, knightRoomBehind(next.x, player.x))) } : {}),
        })
      }
      return { boss: next, enteredActive }
    }
    case 'telegraph': {
      const atk = boss.currentAttack
      if (!atk) return enterState(next, 'idle', { currentAttack: null, currentString: null, beatIndex: 0 })
      // 致命を弾ける仕組み (既定・旧は DEV ?execParry=off・src/exec_parry.ts): 崩れた主人公へ普通の技の溜めを続けない。溜めの途中でも致命の溜めへ切り替える。
      if (execStunActive(player, next.id) && !atk.bossFinisher && !atk.playerLethal) {
        const finisher = getBossFinisherFor(next, player, bounds)
        if (finisher) {
          // 宙の溜め (覚醒王の壁走りの壁) で崩れを見た時は、溜めの頭で床へ降りる (src/stun_cut.ts・旧 ?stunCut=0 は今のまま)。
          const alt = stunCutOn() ? next.altitudePx ?? 0 : 0
          return enterState(alt > 0 ? { ...next, facing: player.x < next.x ? 'left' : 'right' } : next, 'telegraph', {
            currentAttack: finisher, currentString: null, beatIndex: 0, behindMs: 0, actionAnchorX: next.x,
            ...(alt > 0 ? { finisherDropFromPx: alt } : {}),
          })
        }
      }

      const beat = boss.currentString?.beats[boss.beatIndex]
      const chargeMs = beat?.chargeOverrideMs ?? atk.chargeMs
      // 台本の技: 位置・高さ・向きは台本が決める (構えの間もその場で溜める区間として進む)。
      if (atk.choreography === 'awokenRampageV5') next = tallySpirits(advanceChoreo(next, player, atk, bounds), atk)
      // 鶏の宙廻り (ラボ専用・src/rooster_aerial_roam.ts): 飛び上がり〜宙を跳ぶ〜降りる一撃の位置・高さ・向きを台本が決める。
      //   溜めの長さ (chargeMs) が着地の時刻なので、届く時刻は立ち位置によらず一定。
      else if (atk.choreography === 'roosterAerialRoam') next = advanceRoosterRoam(next, player, atk, bounds)
      // 鶏の縦の2技 (src/rooster_vertical.ts): 鳴く → 真上へ → 羽を降らす／主人公の上へ寄って落ちる。
      else if (atk.choreography === 'roosterDawnCall' || atk.choreography === 'roosterCrowDrop' || atk.choreography === 'roosterCrowFinale') next = advanceRoosterVertical(next, player, atk, bounds)

      // 密着派生 (2026-07-06・処刑人C6 一心式): proximitySwitch 指定時、溜め中にプレイヤーが
      //   withinPx へ「居続けた」累計が sustainMs に達した状態で atMs を跨いだら、攻撃を
      //   toAttackId へ瞬時に切り替える (telegraph を頭からやり直す=派生技の読みは新規に走る)。
      //   離れた瞬間リセット = 「ずっと張り付いてる」だけを罰する。string ビート中は対象外。
      if (atk.proximitySwitch && !boss.currentString && !atk.playerLethal && !atk.bossFinisher) {
        const psw = atk.proximitySwitch
        const close = Math.abs(player.x - next.x) <= psw.withinPx
        const held = close ? boss.proximityHeldMs + FIXED_DT * 1000 : 0
        next = { ...next, proximityHeldMs: held }
        if (elapsedMs >= psw.atMs && held >= psw.sustainMs) {
          const to = getAttack(psw.toAttackId)
          const transitioned = enterState(next, 'telegraph', {
            currentAttack: to,
            comboHitIndex: 0,
            behindMs: 0,
            proximityHeldMs: 0,
            actionAnchorX: next.x,
          })
          return { boss: transitioned.boss, enteredActive }
        }
      }

      // 欲張り分岐 (2026-08-31 ユーザー裁定「Aで」・処刑人 exec_maulSet 専用): 距離ではなく
      //   「溜め中に殴られた回数」で罰する。カウント (greedHitCount) は combat.ts の
      //   resolvePlayerAttack がプレイヤー攻撃の命中時に積む。ここでは前 tick までの値を見て
      //   切り替えるだけ (proximityHeldMs と同じ「切替は boss.ts 側」の役割分担・1tick遅れは許容)。
      //   preActiveLunge 開始後 (急接近フェーズ) は切替対象外＝combat.ts のカウント対象外と同じ線。
      //   🔴 旧 proximitySwitch の `!boss.currentString` 除外はここでは付けない: このボスは全攻撃が
      //     strings 経由で telegraph に入るため currentString が常に非null＝その除外を付けると
      //     greedSwitch も実プレイで一生発火しない (距離分岐が「実プレイで機能してこなかった」の
      //     一因と思われる。旧実装の修正はこの票の範囲外なので現状のまま残す)。
      //   正本 = docs/candidates/2026-08-31-executioner-greed-branch-design.md
      if (atk.greedSwitch && !atk.playerLethal && !atk.bossFinisher) {
        const rushStartMs = atk.preActiveLungeMs != null ? Math.max(0, chargeMs - atk.preActiveLungeMs) : Infinity
        if (elapsedMs < rushStartMs && boss.greedHitCount >= atk.greedSwitch.hits) {
          const to = getAttack(atk.greedSwitch.toAttackId)
          const transitioned = enterState(next, 'telegraph', {
            currentAttack: to,
            comboHitIndex: 0,
            behindMs: 0,
            greedHitCount: 0,
            actionAnchorX: next.x,
          })
          return { boss: transitioned.boss, enteredActive }
        }
      }

      // 向き直り (combat-feel-v2 §4.3): 追う技 (払い系) だけ telegraph 中もプレイヤーへ向き直す。
      //   突きには付けない = 回避で裏へ抜ける褒美を残す。
      //   ⚠️ 2026-07-02: preActiveLungeMs 指定時は急接近フェーズ中の facing を凍結する。
      //     急接近でプレイヤーを追い越した瞬間に facing が反転→ dir 反転で後方瞬間移動するバグ回避。
      //     プロ流儀 (SEKIRO/Souls): コミットしたら振り向かない。
      const inRushWindow = !!atk.preActiveLungeMs && elapsedMs > Math.max(0, chargeMs - atk.preActiveLungeMs)
      const inFacingLockWindow = atk.facingLockBeforeActiveMs != null
        && elapsedMs >= Math.max(0, chargeMs - atk.facingLockBeforeActiveMs)
      // 溜めの頭の飛び退きの間 (telegraphBackstepMs) は向きを変えない。床の帯の中心は溜めに入った瞬間の向きで決めた
      //   飛び退き先に固定する (hits.ts spawnZoneHits)。飛び退き中に主人公が反対側へ抜けて向きが反転すると、
      //   飛び退きが戻って突き立ての場所と帯の中心が 26〜89px ずれていた (2026-10-10)。飛び退きが終われば通常どおり向き直る。
      const inBackstepWindow = !!atk.telegraphBackstepPx && !atk.playerLethal && !atk.bossFinisher
        && elapsedMs - FIXED_DT * 1000 < (atk.telegraphBackstepMs ?? 220)  // 最後の1歩の tick まで含める
      if (atk.reboundFromWall) {
        next = { ...next, facing: wallReboundFacing(next) }
      } else if (atk.turnsDuringTelegraph && !inRushWindow && !inFacingLockWindow && !inBackstepWindow) {
        // 常時すり抜け時も中心±24pxでは向きを保持し、1px往復による鏡像チラつきを防ぐ (壁に背をつけた主人公だけは向き直る)。
        next = { ...next, facing: turnTowardPlayer(next, player) }
      }

      // 重要 (2026-06-02 修正): telegraph 中はボスを「動かさない」(急接近フェーズを除く)。
      //   旧実装は telegraph 後半に無言で滑って詰めていた (gap-close slide) が、
      //   「予備動作中なのにもう攻撃してきてる」ように見えてキモい、 とプレイテストで判明。
      //   → 間合い詰めは「攻撃アクション本体 (active の踏み込み lunge)」へ全面移行した。
      //   telegraph はその場で溜める = 読みの時間。 ここで動かさないのが正しい挙動。
      //   位置避け不可は active の lunge が player を捉えることで成立させる (下記)。
      //   ⚠️ 例外: preActiveLungeMs 指定時 = telegraph 末尾で意図的に前方へ滑る (kite 対策)。
      //   ⚠️ 例外2: telegraphCreepDistance 指定時 = 溜め全体を通して等速でにじり寄る (下記)。

      // 溜めの頭の飛び退き (2026-09-03 第4便・介錯 exec_maulQuake 用)。telegraph 開始から
      //   telegraphBackstepMs の間に、向いている方向と逆へ telegraphBackstepPx だけ実座標を
      //   下げる (easeOut・壁でクランプ)。狙い = 主人公を割れ目の帯 (ボスの周り110pxより外) の
      //   中に立たせ、「懐へ走り込むか、その場で1発を回避するか」を選ばせる。
      //   床ハザード (hazardSpawns anchor:'boss') の座標は飛び退き後の位置で固定する (hits.ts spawnZoneHits)。
      if (atk.telegraphBackstepPx && !atk.playerLethal && !atk.bossFinisher) {
        const backstepMs = atk.telegraphBackstepMs ?? 220
        const easeOutQuad = (t: number): number => 1 - (1 - t) ** 2
        const tNow = Math.max(0, Math.min(1, elapsedMs / backstepMs))
        const tPrev = Math.max(0, Math.min(1, (elapsedMs - FIXED_DT * 1000) / backstepMs))
        const step = (easeOutQuad(tNow) - easeOutQuad(tPrev)) * atk.telegraphBackstepPx
        if (step !== 0) {
          const dir = next.facing === 'right' ? 1 : -1
          const newX = next.x - dir * step
          next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, newX)) }
        }
      }

      // 🔵 2026-08-27 夜: exec_maulSet からは外した（90px/2.9秒は実機で知覚できず・分岐技化で置換）。仕組みは汎用 opt-in として残す。
      // じりじり詰め (2026-08-27 ユーザー裁定・exec_maulSet 専用)。
      //   telegraphCreepDistance 指定時、溜めの 10%〜93% の間だけボスが等速で前方へ
      //   telegraphCreepDistance px にじり寄る。 狙い = 2.9秒の長い溜めが「止まっている」と
      //   読まれるのを防ぐこと (溜めの拍=chargeMs そのものは変えない)。
      //   🔴 2026-06-02 に却下された「gap-close slide」との違い = あれは全技で無言のまま滑り、
      //     「予備動作中なのにもう攻撃してきてる」と読まれて撤去された。 これはこの技だけへ明示的に
      //     値を入れる opt-in で、さらに 0.93 以降は完全静止する (下限は boss_pose_timeline.ts の
      //     exec_maulSet キー配置に合わせた。 0.93 以降は同じ値を重ねた「離れ」の合図)。
      //     0.93 より後は絶対に動かさない。
      //   preActiveLungeMs (末尾の急接近・ease-in) との違い = あちらは kite 対策の「急に来る」、
      //     こちらは溜め全体を通した等速の「じりじり来る」。 併用可能だが exec_maulSet は
      //     creep だけを使う。
      //   詰めすぎ防止: プレイヤーとの間合いが telegraphCreepStopGapPx 以下になったら、
      //     そのフレームは進まない (離れればまた詰め始める)。
      if (atk.telegraphCreepDistance && !atk.playerLethal && !atk.bossFinisher) {
        const creepStartMs = chargeMs * 0.10
        const creepEndMs = chargeMs * 0.93
        const dtMs = FIXED_DT * 1000
        const pNow = Math.max(0, Math.min(1, (elapsedMs - creepStartMs) / (creepEndMs - creepStartMs)))
        const pPrev = Math.max(0, Math.min(1, (elapsedMs - dtMs - creepStartMs) / (creepEndMs - creepStartMs)))
        let step = (pNow - pPrev) * atk.telegraphCreepDistance   // 等速 (ease をかけない)
        const gap = Math.abs(player.x - next.x)
        if (gap <= (atk.telegraphCreepStopGapPx ?? 0)) step = 0
        if (step !== 0) {
          const dir = next.facing === 'right' ? 1 : -1
          const newX = attackStopAtReach
            ? clampToBossCoreFront(next.x + dir * step, next.x, player.x, dir, atk, next)
            : next.x + dir * step
          next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, newX)) }
        }
      }

      // 溜め終盤の急接近 (2026-07-02 導入・処刑人 C6 用)。
      //   preActiveLungeMs / preActiveLungeDistance 指定時、telegraph の末尾でボスが前方へ滑って詰める。
      //   狙い: 3秒溜めの重い一撃で「離れれば安全」を封じる (kite 対策)。
      //   実装: 各フレームの ease-in 進捗差分 (delta ≥ 0) を dir に沿って boss.x に積む。
      //     actionAnchorX に依存しない = 通常攻撃 telegraph 突入で anchor リセットされない問題を回避 (2026-07-02 バグ修正)。
      //     facing は inRushWindow 中は凍結されている (上のブロック) = dir が rush 中に反転しない。
      if (atk.preActiveLungeMs && atk.preActiveLungeDistance && !atk.playerLethal && !atk.bossFinisher) {
        const rushStartMs = Math.max(0, chargeMs - atk.preActiveLungeMs)
        if (elapsedMs > rushStartMs) {
          const dtMs = FIXED_DT * 1000
          const pNow = Math.min(1, (elapsedMs - rushStartMs) / atk.preActiveLungeMs)
          const pPrev = Math.max(0, Math.min(1, (elapsedMs - dtMs - rushStartMs) / atk.preActiveLungeMs))
          // 既定 = ease-in (「急に来る」感)。'smooth' = 当たる瞬間に速さ 0 (踏み出した前足が着いて止まる)。
          const ease = atk.preActiveLungeEase === 'smooth' ? (p: number) => p * p * (3 - 2 * p) : (p: number) => p * p
          const easedNow = ease(pNow)
          const easedPrev = ease(pPrev)
          //   戴冠獣の のしかかりだけ、主人公の歩きが速くなった分 (7 版目 a で 130) を延ばす = 下がり続けても届く (理由 = lunaWalkPounceExtraPx)
          const lungeDistance = atk.preActiveLungeDistance + (atk.id === 'houndPounce' ? lunaWalkPounceExtraPx() : 0)
          const step = (easedNow - easedPrev) * lungeDistance   // ≥ 0 (単調非減少)
          const gap = Math.abs(player.x - next.x)
          if (atk.preActiveLungeStopGapPx && gap <= atk.preActiveLungeStopGapPx) {
            // 進まないだけ。離れればまた詰める (telegraphCreepStopGapPx と同じ扱い)
            //   preActiveLungeMinPx の技は、内側でもその分だけ前へ出る (主人公の体の手前で止まる)。
            if (atk.preActiveLungeMinPx) {
              const dir = next.facing === 'right' ? 1 : -1
              const minStep = (easedNow - easedPrev) * atk.preActiveLungeMinPx
              const newX = clampToBossCoreFront(next.x + dir * minStep, next.x, player.x, dir, atk, next)
              next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, newX)) }
            }
          } else if (step !== 0) {
            const dir = next.facing === 'right' ? 1 : -1
            const newX = attackStopAtReach
              ? clampToBossCoreFront(next.x + dir * step, next.x, player.x, dir, atk, next)
              : next.x + dir * step
            next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, newX)) }
          }
        }
      }

      // 処刑フィニッシャーの決然とした踏み込み: playerLethal または bossFinisher 攻撃のみ、 telegraph 中に
      //   boss.x を actionAnchorX → player.x ± finisherAnchorOffset へ線形補間して寄せる。
      //   通常 telegraph は動かない原則を維持 (SEKIRO の掴みダッシュに相当する finisher 専用例外)。
      //   player は stunned で固定なのでターゲット座標も固定。 間合い内なら寄せ不要 (totalDist≤10)。
      if (atk.uniqueExec) {
        // 騎士と花嫁の固有の致命 (DEV ?execUnique=1・src/exec_unique.ts): 段取りどおりに間合いと向きを決める。
        //   騎士は歩き去る間だけ主人公と逆を向く (歩きの絵が反転して出る)。背を向けて立つ turn・止まりの K1 は絵そのものが背中なので、向きは主人公へ。
        //   騎士の壁ぎわの駆け抜け (K-4・10-12) だけは途中で主人公の反対側へ回る (pose.side = -1)。側は溜めの頭の位置 (actionAnchorX) から数える。
        const dir0 = boss.actionAnchorX >= player.x ? -1 : 1   // 溜めの頭の、ボスから見た主人公の向き
        const pose = execUniquePoseAt(atk.uniqueExec, elapsedMs)
        const dir = dir0 * (pose.side ?? 1)
        const toward: Boss['facing'] = dir > 0 ? 'right' : 'left'
        const away: Boss['facing'] = dir > 0 ? 'left' : 'right'
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, player.x - dir * pose.gapPx)),
          facing: pose.faceAway ? away : toward }
      } else if (atk.devour) {
        // 覚醒王の致命「灰を食む」の比較版 (DEV ?awokenDevour・src/awoken_devour.ts): 段取りどおりに
        //   後ろ跳び → 構え → 噛むたびに寄る → その場で溜める → 低い弧で飛び込んで噛む間合いへ。
        const dir = boss.x >= player.x ? -1 : 1   // ボスから見た主人公の向き (間合いは常に 100px 以上あるので途中で入れ替わらない)
        const { gapPx, altitudePx } = awokenDevourGapAt(atk.devour, elapsedMs)
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, player.x - dir * gapPx)), altitudePx }
      } else if ((atk.playerLethal || atk.bossFinisher) && atk.choreography !== 'roosterCrowFinale') {
        // 鶏の終幕の鬨は台本 (src/rooster_vertical.ts) が x・高さを決めるので、ここでは寄せない。
        // 覚醒王の暴噛・終は口 (前方117px) が主人公に重なる所まで寄せる (2026-09-26・噛みは口の周りだけ当たる)。
        const anchorOffset = awokenBiteLandingGapPx(boss, atk) ?? BOSS_EXECUTE_APPROACH_PX
        const bossIsRight = boss.actionAnchorX >= player.x
        const targetX = player.x + (bossIsRight ? anchorOffset : -anchorOffset)
        const totalDist = Math.abs(targetX - boss.actionAnchorX)
        if (next.exec && atk.id === 'executioner_finisher' && execApproachMode() === 'step') {
          // 介錯の執行: 溜めの頭で前ステップを1歩踏んで着く (src/exec_finisher_step.ts)。着く点と時刻は下の等速と同じ。
          //   近すぎて着く点が後ろになる時は踏まず、その場で掲げる (後ろへ跳んで前へ戻って見えた・10-20)。
          if (finisherStepWanted(boss.actionAnchorX, targetX, player.x)) {
            const plan = next.currentAttack?.finisherStep
              ?? finisherStepPlan(boss.actionAnchorX, Math.max(bounds.leftWall, Math.min(bounds.rightWall, targetX)))
            const at = finisherStepAt(plan, elapsedMs)
            next = { ...next, x: at.x,
              currentAttack: next.currentAttack?.finisherStep ? next.currentAttack : { ...atk, finisherStep: plan },
              exec: { ...next.exec, step: at.step } }
          }
        } else if (totalDist > 10) {
          const progress = chargeMs > 0 ? Math.min(1, elapsedMs / chargeMs) : 1
          const lerpX = boss.actionAnchorX + (targetX - boss.actionAnchorX) * progress
          next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, lerpX)) }
        }
        // 宙で崩れを見た (覚醒王の大暴れの壁際・跳び噛みの段取りが組めない時・src/stun_cut.ts): 溜めの頭で床へ降りる (1コマで床へ跳ばない)。
        if (next.finisherDropFromPx) {
          const p = Math.min(1, elapsedMs / FINISHER_DROP_MS)
          next = { ...next, altitudePx: next.finisherDropFromPx * (1 - p * p) }
        }
      }

      if (elapsedMs >= chargeMs) {
        // active 突入時に「踏み込みの着地目標」を確定する。
        //   位置避け不可な lunge 攻撃は、 ここで player の現在位置を起点に
        //   「range-buffer まで踏み込む」距離を逆算して lungeTargetX に焼き込む。
        //   → telegraph 終了時点でプレイヤーが後退していても、 踏み込みがそこへ届く。
        const lungeTargetX = computeLungeTargetX(next, player, atk)
        // 判定の寿命も移動尺と一致させる。広い部屋でも途中で判定だけ消えない。
        // 戴冠獣の駆け抜け: 走る長さはこの時の主人公の向こうまでの距離で決める (src/hound_pass_through.ts houndPassPlan)。
        const passPlan = atk.id === HOUND_PASS_ATTACK_ID && next.id === 'dream-hound' ? houndPassPlan(next, player.x) : undefined
        const chargeRunMs = atk.id === 'knightWallCharge'
          ? knightChargeRunMs(next.x, next.facing === 'right' ? 1 : -1) : passPlan?.runMs
        const wallAttack = chargeRunMs !== undefined
          ? { ...atk, activeMs: Math.max(FIXED_DT * 1000, chargeRunMs) }
          : atk.wallContactInsetPx != null && atk.lungeDistance
          ? { ...atk, activeMs: Math.max(FIXED_DT * 1000, Math.abs(lungeTargetX - next.x) / atk.lungeDistance * atk.activeMs) }
          : atk
        const transitioned = enterState(next, 'active', {
          currentAttack: wallAttack,
          actionAnchorX: next.x,
          knightLeapTotalPx: atk.id === 'lanceCross'
            ? next.knightLeapTotalPx ?? Math.max(0, Math.min(180, knightRoomBehind(next.x, player.x))) : undefined,
          // 切り下がりの踏み込み = 薙ぎと同じ止まり方 (主人公の 85.6px 手前・最大 90px)。近すぎる時は縮む (0 = その場で払う)。
          knightCrossLungePx: atk.id === 'lanceCross' && boss.id === 'vigil-knight'
            ? Math.max(0, Math.min(KNIGHT_CROSS_LUNGE_MAX_PX, (player.x - next.x) * (next.facing === 'right' ? 1 : -1) - knightSpearLungeGap({ id: 'lanceSweep' })!))
            : undefined,
          knightChargeRunMs: passPlan ? undefined : chargeRunMs,
          knightChargeDir: atk.id === 'knightWallCharge' ? (next.facing === 'right' ? 1 : -1) : undefined,
          ...(passPlan ? { houndPassRunMs: passPlan.runMs, houndPassDir: passPlan.dir } : {}),
          lungeTargetX: passPlan ? passPlan.runEndX : lungeTargetX,
          comboHitIndex: 0,  // 新規攻撃なのでヒット番号リセット
        })
        return { boss: transitioned.boss, enteredActive: true }
      }
      return { boss: next, enteredActive }
    }
    case 'active': {
      // Only the chase's first hit uses the shared pass-through movement.
      const atk = isAwokenChaseStudy(boss) && boss.comboHitIndex === 0
        ? awokenRushStudyAttack(boss.currentAttack!) : boss.currentAttack
      if (!atk) return enterState(next, 'idle', { currentAttack: null, currentString: null, beatIndex: 0 })

      // 処刑は telegraph で接触(BOSS_EXECUTE_APPROACH_PX)まで寄せ済み。active の
      // ホーミング突進(range-buffer狙い)は接触位置から後退させる=スライドバックになるので切る。
      // 接触位置のまま刺し切る(全ボス共通)。
      if (atk.choreography === 'awokenRampageV5') {
        // 台本の技 (大暴れ第5案): 踏み込み・停止間合いを通らず、台本が位置・高さ・向きを決める。
        next = tallySpirits(advanceChoreo(next, player, atk, bounds), atk)
      } else if ((atk.choreography === 'roosterAerialRoam' || atk.choreography === 'roosterDawnCall' || atk.choreography === 'roosterCrowDrop' || atk.choreography === 'roosterCrowFinale') && next.comboHitIndex === 0) {
        // 鶏の宙廻りの1発目 = 着地した場所でそのまま打つ (踏み込まない・床の高さ)。2発目からは下の普通の踏み込み (前へ走って爪)。
        next = { ...next, altitudePx: 0 }
      } else if (atk.comboLunge && !atk.playerLethal && !atk.bossFinisher) {
        // 裾乱れ: 連続+ease の前進 (comboAdvanceX)。 active/comboGap 両方で毎フレーム適用=カクつき無し。
        //   gapOnly の技は当たる絵の間は止まる (寄るのは comboGap だけ)。
        if (!atk.comboLunge.gapOnly) next = { ...next, x: comboAdvanceX(next, player, atk, FIXED_DT, bounds) }
      } else if (atk.lungeDistance && !atk.playerLethal && !atk.bossFinisher) {
        const dir = next.facing === 'right' ? 1 : -1
        let lx: number
        if (atk.forwardWarp && atk.forwardWarp.length > 1) {
          // motion-warp: 動画カーブに沿って actionAnchorX → lungeTargetX (active 突入時に確定済み) を進む。
          //   player.x は読まない (前回避対応)。 後退追尾は computeLungeTargetX の lungeCatchUp で担う。
          const progress = elapsedMs / atk.activeMs
          const w = sampleWarp(atk.forwardWarp, progress)
          const desired = boss.actionAnchorX + (boss.lungeTargetX - boss.actionAnchorX) * w
          // 突進中は前方へのみ進む (warp は単調増だが安全側に)
          lx = dir > 0 ? Math.max(boss.x, desired) : Math.min(boss.x, desired)
        } else if (atk.positionEvadable) {
          // 位置避け可: 固定踏み込み。 actionAnchorX → lungeTargetX を線形補間。
          //   プレイヤーを追わないので、 後退すれば踏み込みが届かず「位置避け成立」。
          const progress = Math.min(1, elapsedMs / atk.activeMs)
          lx = boss.actionAnchorX + (boss.lungeTargetX - boss.actionAnchorX) * progress
        } else {
          // 位置避け不可: active 突入時に確定した lungeTargetX へ lungeSpeed 上限で詰める。
          //   毎tick player.x を読まない = 前回避でプレイヤーがボスを通り抜けても再追尾しない。
          //   後退逃げ対策は computeLungeTargetX の lungeCatchUp が担う (active 前に焼き込み済み)。
          const delta = boss.lungeTargetX - boss.x
          const maxMove = awokenFinaleLungeSpeed(boss, atk) * FIXED_DT
          lx = boss.x + Math.sign(delta) * Math.min(maxMove, Math.abs(delta))
        }
        // 通常技は共通の停止間合い、通過技は固定走路を保つ。
        lx = clampToBossCoreFront(lx, next.x, player.x, dir, atk, next)
        lx = Math.max(bounds.leftWall, Math.min(bounds.rightWall, lx))
        next = { ...next, x: lx }
        // 鶏の一戦の爪 (DEV・src/rooster_fight.ts が src/rooster_claw_hop.ts へ入れる): 床を滑らず、小さく跳んで爪を出す (踏み込んだ割合で山なり)。
        const hop = roosterClawHopPx(atk.id)
        if (hop > 0) {
          const total = Math.abs(boss.lungeTargetX - boss.actionAnchorX), done = Math.abs(lx - boss.actionAnchorX)
          next = { ...next, altitudePx: total > 1 && done < total - 0.5 ? hop * Math.sin(Math.PI * done / total) : 0 }
        }
      }
      // 覚醒王の致命の跳び噛みの版 (DEV ?awokenDevour=gladius・src/awoken_devour_pounce.ts): 3回目は宙で顎を閉じた所が当たり (active の頭)。
      //   その後も着地まで宙を進む (active に入った所を起点に、主人公を追わずに段取りの距離だけ)。
      if (atk.devour?.pounce) {
        const fwd = next.facing === 'right' ? 1 : -1
        const g0 = awokenDevourGapAt(atk.devour, atk.devour.chargeMs).gapPx
        const { gapPx, altitudePx } = awokenDevourGapAt(atk.devour, atk.devour.chargeMs + elapsedMs)
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, boss.actionAnchorX + fwd * (g0 - gapPx))), altitudePx }
      }
      // 花嫁の固有の致命 (DEV ?execUnique=1・src/exec_unique.ts): 頭が胸に届いた後、覆い被さる間に今の抱擁の間合いまで寄る (弾かれたら寄らない)。
      if (atk.uniqueExec?.boss === 'bride' && !atk.uniqueExec.parried && player.state !== 'parrying') {
        const dir = boss.x >= player.x ? -1 : 1
        const gap = brideCoverGapAt(atk.uniqueExec, elapsedMs)
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, player.x - dir * gap)) }
      }
      // 騎士の突進・花嫁の押し返し (DEV ?execUnique=1・10-12): 当たった所 (actionAnchorX) から、勢いで滑る・弾かれてのけぞる。
      if (atk.uniqueExec) next = execUniqueAfterX(next, atk.uniqueExec, elapsedMs, bounds)
      if (atk.id === 'lanceCross' && boss.id === 'vigil-knight') {
        const fwd = boss.facing === 'right' ? 1 : -1
        const d = knightCrossForwardPx(elapsedMs, boss.knightCrossLungePx ?? 0, boss.knightLeapTotalPx ?? 180)
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, boss.actionAnchorX + fwd * d)) }
      } else if (atk.id === 'knightWallCharge' && boss.id === 'vigil-knight') {
        const dir = boss.facing === 'right' ? 1 : -1
        const d = knightChargeRunDistance(Math.min(elapsedMs, atk.activeMs))
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, boss.actionAnchorX + dir * d)) }
      } else if (atk.id === HOUND_PASS_ATTACK_ID && boss.id === 'dream-hound') {
        // 駆け抜け: 主人公を追わず、決めた所 (lungeTargetX) まで走り抜ける。
        const dir = boss.houndPassDir ?? (boss.facing === 'right' ? 1 : -1)
        const total = Math.abs(boss.lungeTargetX - boss.actionAnchorX)
        const d = Math.min(total, houndPassRunDistance(Math.min(elapsedMs, atk.activeMs)))
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, boss.actionAnchorX + dir * d)) }
      }

      if (elapsedMs >= atk.activeMs) {
        // 致命を弾ける仕組み (既定・旧は DEV ?execParry=off): 主人公が崩れていたら、連撃の次の段・連の次の拍・追いの技を捨てて戻りへ (戻りの後は必ず致命)。
        const cutForExecution = execStunActive(player, next.id) && !atk.bossFinisher && !atk.playerLethal
        // 崩れを見て早回しにした振り (src/stun_cut.ts) は、戻りも同じ倍率で早回しする。
        const keepCut = cutForExecution && boss.cutRecovery
          ? { cutRecovery: { rate: boss.cutRecovery.recRate ?? boss.cutRecovery.rate, fromActive: false,
            ...(boss.cutRecovery.recPoseHold ? { holdUntilMs: cutPoseHoldMs(next, atk, beatRecoveryMs(next, atk)) } : {}) } } : {}
        const hasNextComboHit = !!atk.comboHits && comboGapForHit(atk, boss.comboHitIndex) !== undefined
          && boss.comboHitIndex < atk.comboHits - 1
        if (!cutForExecution && !hasNextComboHit && shouldChainAwokenPocketSpin(next, player)) {
          return enterState(next, 'telegraph', {
            currentAttack: getAttack('feralPocketSpin'), currentString: null, beatIndex: 0,
            awokenSpinStreak: (next.awokenSpinStreak ?? 0) + 1,
            actionAnchorX: next.x, lungeTargetX: next.x, behindMs: 0,
          })
        }
        if (next.id === 'crowned-king-awoken' && atk.id === 'feralPocketSpin') {
          const facing = player.x < next.x ? 'left' : 'right'
          const oldDir = next.facing === 'right' ? 1 : -1
          const newDir = facing === 'right' ? 1 : -1
          const pivotX = next.x + oldDir * AWOKEN_SPIN_FRONT_PAW_OFFSET_PX
          const x = Math.max(bounds.leftWall, Math.min(bounds.rightWall,
            pivotX - newDir * AWOKEN_SPIN_FRONT_PAW_OFFSET_PX))
          return enterState(next, 'recovery', { recoveryRecenterMovedPx: 0, facing, x, ...keepCut })
        }
        // 床攻撃後は抽選済みの連携によらず、600ms後の距離だけで発勁を決める。
        // 明示的に発勁を外したDEV比較は従来の譜面を維持する。
        // 🔵 2026-10-02: 地割り→発勁は幕1から (通しパック P-1 の前倒し)。榴弾は砲形態＝幕2だけ。
        const floorFajinId = boss.id === 'the-executioner'
          ? atk.id === 'exec_maulQuake' ? 'exec-maul-quake-fajin'
            : atk.id === 'exec_cannonMortar' && boss.executesTaken >= 1
              && executionerStringEnabled('exec-cannon-mortar-fajin')
              ? 'exec-cannon-mortar-fajin' : null
          : null
        if (floorFajinId && !cutForExecution) {
          const followup = getBossDefinitionById(boss.id)!.strings!.find(s => s.id === floorFajinId)!
          return enterState(next, 'beatGap', { currentString: followup, beatIndex: 0 })
        }
        if (!cutForExecution && atk.comboHits && comboGapForHit(atk, boss.comboHitIndex) !== undefined
            && boss.comboHitIndex < atk.comboHits - 1) {
          return enterState(next, 'comboGap', {})
        }
        if (!cutForExecution && boss.currentString && boss.beatIndex < boss.currentString.beats.length - 1) {
          return enterState(next, 'beatGap', {})
        }
        // 獣比較: 相手が頭の下か背後なら、勢いで通り越す量をここで1回だけ決める (追わない)。
        const carry = beastWhiffCarry(next, player)
        const transitioned = enterState(next, 'recovery', { recoveryRecenterMovedPx: 0, ...(carry ? { whiffCarry: carry } : {}), ...keepCut })
        if (boss.id === 'vigil-knight' && (atk.id === 'lanceCross' || atk.id === 'knightWallCharge')) {
          return { ...transitioned, boss: { ...transitioned.boss, stateElapsed: Math.max(0, elapsedMs - atk.activeMs) / 1000 } }
        }
        return transitioned
      }
      return { boss: next, enteredActive }
    }
    case 'comboGap': {
      const atk = boss.currentAttack
      const gapMs = atk ? comboGapForHit(atk, boss.comboHitIndex) : undefined
      if (!atk || gapMs === undefined) return enterState(next, 'recovery', { recoveryRecenterMovedPx: 0 })
      // 致命を弾ける仕組み (既定・旧は DEV ?execParry=off): 段の間で崩れたら、次の段を出さずに戻りへ。
      if (execStunActive(player, next.id) && !atk.bossFinisher) return enterState(next, 'recovery', { recoveryRecenterMovedPx: 0 })
      // 剣舞の手拍子の致命 (src/blade_finisher_v2.ts・既定): 1撃目が当たって崩れが解けたら、2撃目は出さない。
      if (atk.bladeClap && player.state !== 'stunned') return enterState(next, 'recovery', { recoveryRecenterMovedPx: 0 })
      // Turn exactly once with the visible coil, then commit through the next bite.
      if (isAwokenChaseStudy(boss)
        && boss.stateElapsed * 1000 < AWOKEN_CHASE_CUE_MS && elapsedMs >= AWOKEN_CHASE_CUE_MS) {
        next = { ...next, facing: player.x < next.x ? 'left' : 'right' }
      }
      // 連続前進 (裾乱れ): gap 中も動かして start-stop のカクつきを消す (comboAdvanceX)。
      if (atk.comboLunge && !atk.playerLethal && !atk.bossFinisher) {
        next = { ...next, x: comboAdvanceX(next, player, atk, FIXED_DT, bounds) }
      }
      next = settleBossAttackTravel(next, player, gapMs)
      if (elapsedMs >= gapMs) {
        // 次のヒットへ突入 (enteredActive で次の段の melee ヒットが湧く)。
        //   連撃の各ヒットも踏み込み目標を再計算 → 後退し続けても各撃が踏み込んで届く。
        const lungeTargetX = computeLungeTargetX(next, player, atk)
        const transitioned = enterState(next, 'active', {
          comboHitIndex: boss.comboHitIndex + 1,
          actionAnchorX: next.x,
          lungeTargetX,
        })
        return { boss: transitioned.boss, enteredActive: true }
      }
      return { boss: next, enteredActive }
    }
    case 'recovery': {
      const atk = boss.currentAttack
      if (!atk) return enterState(next, 'idle', { currentAttack: null, currentString: null, beatIndex: 0 })
      const beat = boss.currentString?.beats[boss.beatIndex]
      const recoveryMs = beat?.recoveryOverrideMs ?? atk.recoveryMs
      next = settleBossAttackTravel(next, player, recoveryMs)
      // 獣比較: 空振りの勢い。踏み込みと同じ速さで入り、減速して止まる。差分で進め、終了時に吸着しない。
      if (next.whiffCarry) {
        const { fromX, targetX, durationMs } = next.whiffCarry
        const step = whiffCarryProgress(elapsedMs, durationMs) - whiffCarryProgress(elapsedMs - FIXED_DT * 1000, durationMs)
        if (step > 0) next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, next.x + (targetX - fromX) * step)) }
      }
      // 「前へ手を伸ばす」絵 (掴み/致命) が recovery に入る攻撃: recovery 前半で前方ドリフト。
      //   active の lunge は active 終了で止まるため、 これが無いと recovery で停止して見える
      //   (= 掴みが「その場で手を伸ばす」になる)。 facing 方向 = 伸ばす向き (2026-06-14 花嫁プレイテスト)。
      // 固有の致命 (DEV ?execUnique=1) を弾かれた時は前へ出ない (弾かれた姿のまま主人公の方へ 55px 滑っていた・10-09 夜)。
      if (atk.recoveryDriftPx && !atk.uniqueExec?.parried) {
        const driftPhase = 0.5   // 前半で手を伸ばし切り、 後半は崩れる (空振り)
        if (elapsedMs < driftPhase * recoveryMs) {
          const dir = next.facing === 'right' ? 1 : -1
          const driftSpeed = atk.recoveryDriftPx / (driftPhase * (recoveryMs / 1000))  // px/s
          let dx = next.x + dir * driftSpeed * FIXED_DT
          // 🔴 主人公を追い越さない (2026-07-27・active / neutral 歩きと同じ作法)。
          //   当たり判定が終わった後のドリフトだけ芯を見ておらず、主人公が止まっている中を
          //   ボスが歩き続けていた。 押し戻さない / passThroughBody は従来どおり素通り。
          if (BOSS_CORE.stopRecoveryDrift) dx = clampToBossCoreFront(dx, next.x, player.x, dir, atk, next, true)
          const nx = Math.max(bounds.leftWall, Math.min(bounds.rightWall, dx))
          next = { ...next, x: nx }
        }
      }
      if (atk.uniqueExec) next = execUniqueAfterX(next, atk.uniqueExec, atk.activeMs + elapsedMs, bounds)
      // 崩れを見て当たりの途中から戻りへ入った時 (src/stun_cut.ts) は、走り抜け・切り下がりの戻りの決まった位置へ合わせない
      //   (当たりを最後まで走っていないので、決まった位置へ寄せると1コマで跳ぶ)。今いる所で戻る。
      if (boss.cutRecovery?.fromActive) {
        // その場で戻る (下の3つの位置合わせを飛ばす)
      } else if (atk.id === 'lanceCross' && boss.id === 'vigil-knight') {
        const fwd = boss.facing === 'right' ? 1 : -1
        const s = atk.activeMs + elapsedMs
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall,
          boss.actionAnchorX + fwd * knightCrossForwardPx(s, boss.knightCrossLungePx ?? 0, boss.knightLeapTotalPx ?? 180))) }
      } else if (atk.id === 'knightWallCharge' && boss.id === 'vigil-knight') {
        const dir = boss.knightChargeDir ?? (boss.facing === 'right' ? 1 : -1)
        const start = knightChargeStopX(dir) - dir * KNIGHT_CHARGE_BRAKE_DISTANCE
        const x = start + dir * knightChargeScrapeDistance(elapsedMs)
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, x)) }
        if (elapsedMs >= KNIGHT_CHARGE_SCRAPE_MS + 300 + 220) {
          next = { ...next, facing: dir === 1 ? 'left' : 'right' }
        }
      } else if (atk.id === HOUND_PASS_ATTACK_ID && boss.id === 'dream-hound') {
        // 駆け抜けの止まり: 走り終わり (lungeTargetX) から 60px を滑って止まる。向きは保つ (振り返りは待機で)。
        const dir = boss.houndPassDir ?? (boss.facing === 'right' ? 1 : -1)
        const x = boss.lungeTargetX + dir * houndPassSkidDistance(elapsedMs)
        next = { ...next, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, x)) }
      }
      // 崩れを見て打ち切った戻り (src/stun_cut.ts・10-12 F-1 の既定): 戻りの絵を1枚ずつ等速で holdUntilMs まで見せたら、次の絵の頭へ進む。
      //   最後の絵を見せ終えたら、残りを待たずに致命の溜めへ。前の早回し (DEV ?stunCutLook=warp) は holdUntilMs を持たない。
      const cutHold = boss.cutRecovery?.holdUntilMs
      const cutLive = cutHold !== undefined && elapsedMs >= cutHold && elapsedMs < recoveryMs
        && stunCutOn() && execStunActive(player, next.id) && !atk.bossFinisher && !atk.playerLethal
      const nextKeyMs = cutLive ? cutRecoveryKeyStartsMs(boss, atk, recoveryMs).find(ms => ms > elapsedMs + 1e-6 && ms < recoveryMs) : undefined
      if (cutLive && nextKeyMs !== undefined) {
        next = { ...next, stateElapsed: nextKeyMs / 1000,
          cutRecovery: { ...boss.cutRecovery!, holdUntilMs: nextKeyMs + cutPoseHoldMs(boss, atk, recoveryMs) } }
      } else if (cutLive) {
        // 介錯: 戻りを最後まで出した時と同じく、1手打ち終えた数え (幕2の組み変わりの判定) を進める。
        const finished = next.exec ? { ...next, exec: onAttackFinished(next.exec, next.executesTaken, next.attackCount, atk.id) } : next
        const finisher = getBossFinisherFor(finished, player, bounds)
        if (finisher) {
          return enterState({ ...finished, facing: turnTowardPlayer(finished, player) }, 'telegraph', {
            currentAttack: finisher, currentString: null, beatIndex: 0, behindMs: 0, actionAnchorX: finished.x,
            attackCount: boss.attackCount + 1,
          })
        }
      }
      if (elapsedMs >= recoveryMs) {
        // 請われぬ介錯: 1手打ち終えた境界だけで、幕2の決定的な変形判定を行う。
        if (next.exec) {
          next = { ...next, exec: onAttackFinished(next.exec, next.executesTaken, next.attackCount, atk.id) }
        }
        // 崩れを見て打ち切った戻りの終わり (src/stun_cut.ts): 待機を通らずに致命の溜めへ (背後の応手・次の一手の抽選より先)。
        if (stunCutOn() && execStunActive(player, next.id) && !atk.bossFinisher && !atk.playerLethal) {
          const finisher = getBossFinisherFor(next, player, bounds)
          if (finisher) {
            return enterState({ ...next, facing: turnTowardPlayer(next, player) }, 'telegraph', {
              currentAttack: finisher, currentString: null, beatIndex: 0, behindMs: 0, actionAnchorX: next.x,
              attackCount: boss.attackCount + 1,
            })
          }
        }
        // 背後応手 (§4.3): この攻撃中に裏へ回られ続けたなら、 間を置かず振り向き技で応える。
        //   recovery 自体は中断しない (攻め時の窓は丸ごと残す) = 「裏取り得」だけを消す。
        const definition = getBossDefinitionById(next.id)
        const backResponse = definition?.backAttackByExecutes?.filter(r => r.atExecutes <= next.executesTaken)
          .sort((a, b) => b.atExecutes - a.atExecutes)[0]
        const backId = backResponse?.attackId ?? definition?.backAttackId
        const thresholdMs = backAttackThresholdMsFor(definition)
        // 初登場保証を通らない単発の背後応手で体幹が割れ、未登場の連を残して幕が終わるのを防ぐ。
        // 予約中は通常の待機→未登場連の抽選へ戻す。出し切った後と旧大暴れ・他ボスの応手は従来どおり。
        const debutPending = !debugBypassStrings && rampageV5PendingDebuts(next,
          rampageV5Strings(next, definition?.strings ?? [])).length > 0
        // 変形を予約した手番では背後応手を差し込まず、変形アクションを先に見せる。
        // 覚醒王: 背後の相手が懐 (噛みが届かない) なら振り向き噛みを出さず、待機の抽選・取り直しへ (2026-09-26)。
        // 続けて出す上限 (backAttackMaxChain): 応手の後にまた応手を重ねない。戴冠獣の尾の薙ぎは背中を主人公へ向けたまま
        //   出すので、上限が無いと自分の溜めの間に背面滞在が積もって永久に続いた (2026-10-10)。上限に達したら下の待機へ。
        const backChain = next.backResponseChain ?? 0
        const backMaxChain = backAttackChainCapOn ? definition?.backAttackMaxChain : undefined
        const backChainOpen = backMaxChain === undefined || backChain < backMaxChain
        if (backId && next.behindMs >= thresholdMs && next.exec?.morph !== 'morphing' && !debutPending
          && backChainOpen && !awokenBiteInPocket(next, player, backId)) {
          return enterState(next, 'telegraph', {
            currentAttack: getAttack(backId),
            attackCount: boss.attackCount + 1,
            lastAttackId: backId,
            lastAttackStreak: 1,
            behindMs: 0,
            backResponseChain: backChain + 1,
            facing: backResponse?.facePlayerWithRear
              ? (player.x < next.x ? 'right' : 'left') : player.x < next.x ? 'left' : 'right',
            currentString: null,
            beatIndex: 0,
          })
        }
        // 生きたお見合い (2026-07-19): 攻撃が終わった瞬間に「次の一手」を抽選する。
        //   既定 (standoff 未指定) は press 100% = ここは何も変えない = 現行挙動。
        const pick = pickStandoffBeat(
          definition?.standoff,
          next.attackCount,
          currentStandoffBeat(next),
          next.standoffInARow ?? 0,
          next.standoffSkips,
        )
        // 戴冠獣の駆け抜け: 待機へ入る tick で主人公の方へ向き直る (待機の絵と向きの反転を同じ tick にする)。
        //   旧は向き直りが次の tick の頭 (reFaceNow) だったので、向き直りの絵 (turnFront) の次の1コマだけ待機の絵が走った向きのまま描かれ、
        //   頭が約 205px 逆へ飛んで戻った (2026-10-11 撮影 C:/dev/LUNAIRE-notes/assets/2026-10-11-hound-pass-art/pass-art-measure.md)。
        const passTurn = atk.id === HOUND_PASS_ATTACK_ID && next.id === 'dream-hound'
          ? { facing: turnTowardPlayer(next, player) } : {}
        return enterState(next, 'idle', {
          currentAttack: null, currentString: null, beatIndex: 0,
          standoffBeat: pick.beat, standoffInARow: pick.inARow, standoffSkips: pick.skips,
          ...passTurn,
        })
      }
      return { boss: next, enteredActive }
    }
    case 'blink': {
      // 渦になって消えている間 (描画は render 側でフェード)。 終わったら反対側へ。
      if (elapsedMs >= BLINK_OUT_MS) {
        const dirToPlayer = player.x >= next.x ? 1 : -1
        // プレイヤーを「挟んで」反対側に出る = 横の取り合いの圧 (spec §4)
        let nx = player.x + dirToPlayer * BLINK_REAPPEAR_DIST
        nx = Math.max(bounds.leftWall + 30, Math.min(bounds.rightWall - 30, nx))
        const facing = player.x < nx ? 'left' as const : 'right' as const
        // blinkOnly 連があるボスは、再出現の最初の可視フレームより前に分岐を予約する。
        // currentString/currentAttack を reappear 中の描画が読み、1撃/3撃の銀糸を最初から出せる。
        const def = getBossDefinitionById(next.id)
        const strings = debugBypassStrings ? undefined : def?.strings
        const hasBlinkOnly = strings?.some((s) => s.blinkOnly === true) === true
        if (strings && hasBlinkOnly) {
          const reserving = { ...next, x: nx, facing }
          const str = pickNextString(reserving, player, strings, 'blink')
          const atk = getAttack(str.beats[0]!.attackId)
          return {
            boss: {
              ...reserving,
              state: 'reappear',
              stateElapsed: 0,
              currentString: str,
              currentAttack: atk,
              beatIndex: 0,
              comboHitIndex: 0,
            },
            enteredActive: false,
          }
        }
        return {
          boss: { ...next, x: nx, facing, state: 'reappear', stateElapsed: 0 },
          enteredActive: false,
        }
      }
      return { boss: next, enteredActive }
    }
    case 'reappear': {
      // 再出現を必ず「見せる」(FX+音は game/render 側)。 反応の床 ≥450ms。
      // 2026-07-01: reappear 明けで idle スキップ → 直接次の攻撃 telegraph に遷移 (ユーザー指摘:
      //   「ワープ後即攻撃モーションに入ってほしい」)。 反応の床 470ms は BLINK_REAPPEAR_MS で担保済。
      //   attackGapMs を消化する idle を通ると「ワープ→ぼんやり待ち→攻撃」 で緩む問題を解消。
      if (elapsedMs >= BLINK_REAPPEAR_MS) {
        const cfg = getBossDefinitionById(next.id)?.blink
        const defTuning = getBossDefinitionById(next.id)
        // cooldown リセット + 直後の抽選ボーナス (blinkFollowupPending) を telegraph 突入で明示クリア。
        const cooldownReset: Partial<Boss> = {
          blinkCooldownMs: cfg?.cooldownMs ?? 8000,
          blinkFollowupPending: false,
        }
        // blink中に予約済みの専用連はここで同じ内容のままtelegraphへ入る。
        // 再抽選しない = 再出現中に見せた1本/3本と実際の攻撃が食い違わない。
        if (next.currentString?.blinkOnly && next.currentAttack) {
          const atk = next.currentAttack
          return enterState(next, 'telegraph', {
            ...cooldownReset,
            currentAttack: atk,
            currentString: next.currentString,
            beatIndex: 0,
            attackCount: boss.attackCount + 1,
            lastAttackId: atk.id,
            lastAttackStreak: atk.id === boss.lastAttackId ? boss.lastAttackStreak + 1 : 1,
            behindMs: 0,
          })
        }
        // 2026-07-01 (B): 次の 1 手だけ距離ゾーン補正無視で全等分抽選するフラグを立てる。
        //   selectByWeight で参照 → 抽選後 telegraph 遷移時に blinkFollowupPending: false でクリア。
        next = { ...next, blinkFollowupPending: true }
        // 次の攻撃を即選ぶ (idle の pickNext* 相当を再現)
        const strings = debugBypassStrings ? undefined : defTuning?.strings
        if (strings && strings.length > 0) {
          const str = pickNextString(next, player, strings)
          const atk = getAttack(str.beats[0]!.attackId)
          const crossFacing: Partial<Boss> = atk.crossArena
            ? { facing: player.x < next.x ? 'left' : 'right' }
            : {}
          return enterState(next, 'telegraph', {
            ...cooldownReset,
            currentAttack: atk,
            currentString: str,
            beatIndex: 0,
            lastStringId: str.id,
            attackCount: boss.attackCount + 1,
            lastAttackId: atk.id,
            lastAttackStreak: 1,
            behindMs: 0,
            ...crossFacing,
            ...(atk.crossArena ? { lastCrossArenaAttackCount: boss.attackCount + 1 } : {}),
          })
        }
        // strings 未定義ボス: 従来の attackPool から即選択
        const pool = attackPoolForBoss(defTuning!, next.executesTaken)
        const atk = pickNextAttack(boss, player, pool)
        const streak = atk.id === boss.lastAttackId ? boss.lastAttackStreak + 1 : 1
        return enterState(next, 'telegraph', {
          ...cooldownReset,
          currentAttack: atk,
          attackCount: boss.attackCount + 1,
          lastAttackId: atk.id,
          lastAttackStreak: streak,
          behindMs: 0,
        })
      }
      return { boss: next, enteredActive }
    }
    case 'beatGap': {
      const str = boss.currentString
      const nextIndex = boss.beatIndex + 1
      const beat = str?.beats[nextIndex]
      if (!str || !beat) return enterState(next, 'recovery', { behindMs: 0, recoveryRecenterMovedPx: 0 })
      // 致命を弾ける仕組み (既定・旧は DEV ?execParry=off): 拍の間で崩れたら、連の残りを捨てて戻りへ。
      if (execStunActive(player, next.id)) {
        return enterState(next, 'recovery', { currentString: null, beatIndex: 0, behindMs: 0, recoveryRecenterMovedPx: 0 })
      }
      // 掴んだら連の残りを捨てる技 (花嫁の抱擁の拘束・src/bride_hug_bind.ts): 抱いている間と放した直後に次の拍を確定で入れない。
      if (player.state === 'grabbed' && boss.currentAttack?.grab?.endsString) {
        return enterState(next, 'recovery', { currentString: null, beatIndex: 0, behindMs: 0, recoveryRecenterMovedPx: 0 })
      }
      // gapMs は beat[0] では未使用 (?? 0 = 即時遷移)。 中間拍は定義値の間を置く。
      next = settleBossAttackTravel(next, player, beat.gapMs ?? 0)
      if (elapsedMs >= (beat.gapMs ?? 0)) {
        // Read position AFTER the mortar/quake response, not at string selection.
        // Once fajin telegraph starts, approach cannot cancel that visible promise.
        const fajinFollowup = (str.id === 'exec-cannon-mortar-fajin' && beat.attackId === 'exec_cannonFajin')
          || (str.id === 'exec-maul-quake-fajin' && beat.attackId === 'exec_bladeFajin')
        if (boss.id === 'the-executioner' && fajinFollowup
          && Math.abs(next.x - player.x) < cannonRangeTuning().tooClosePx) {
          return enterState(next, 'recovery', {
            currentString: null, beatIndex: 0, behindMs: 0, recoveryRecenterMovedPx: 0,
          })
        }
        // DEV ?awokenBiteSpace=pick: 噛みの踏み込みの後は主人公の目の前 (約 116px) にいるので、続く噛みは顔が必ず被る。その比較版だけ連をここで切る (配布版の keep は切らない・11-01)。
        if (awokenBiteSpaceCutsBeat(next, player, beat.attackId)) {
          return enterState(next, 'recovery', { currentString: null, beatIndex: 0, behindMs: 0, recoveryRecenterMovedPx: 0 })
        }
        const atk = getAttack(beat.attackId)
        const transitioned = enterState(next, 'telegraph', {
          beatIndex: nextIndex,
          currentAttack: atk,
          ...(atk.reboundFromWall ? { facing: wallReboundFacing(next) } : {}),
          comboHitIndex: 0,
          behindMs: 0,
        })
        return { boss: transitioned.boss, enteredActive: false }
      }
      return { boss: next, enteredActive }
    }
  }
}

// 踏み込み攻撃 (lunge) の「着地 x 座標」を active 突入時に確定する。
//   位置避け不可 (default): プレイヤーの現在位置から「range - buffer」手前を狙う。
//     telegraph 終了時点で後退していても、 その後退先へ踏み込む = 後退だけでは避けられない。
//     ただし踏み込み量には lungeDistance を基準とした上下限を設け、 ワープにも空振りにもしない:
//       - 最大: lungeDistance (定義した最大踏み込み量を超えない = 見た目どおり)
//       - 最小: lungeDistance の minLungeFrac (近すぎても "踏み込む" モーションは出す)
//   positionEvadable:true: プレイヤーを追わず、 定義どおり前方へ lungeDistance だけ踏み込む。
//     → telegraph 終了後にプレイヤーが後退していれば踏み込みが届かず「位置避けできた」になる。
//   壁クランプあり。
// motion-warp 用: 前進割合カーブ arr ([0..1] を等分した値) を progress t∈[0,1] で線形サンプル。
//   配列が無効なら恒等 (t をそのまま返す) = 線形にフォールバック。
export function sampleWarp(arr: number[], t: number): number {
  const n = arr.length
  if (n === 0) return t
  if (n === 1) return arr[0]!
  const x = Math.max(0, Math.min(1, t)) * (n - 1)
  const i = Math.floor(x)
  if (i >= n - 1) return arr[n - 1]!
  const f = x - i
  return arr[i]! * (1 - f) + arr[i + 1]! * f
}

// 裾乱れ系 連撃の移動 (2026-07-10 ユーザー案): 直線ステップ(カクつき)を廃し、 連続(active+comboGap の毎フレーム)
//   ＋イーズで滑らかに詰める。 hit0=追尾で間合いを作り / hit1-6=コミット方向へ連続前進(spin進行で山型ease・
//   プレイヤーは追わない=背後抜けは離れて逃げ窓) / hit7-8=停止(足を止めてズドン)。 数値は comboLunge が持つ⬜暫定。
export function comboAdvanceX(
  boss: Boss, player: Player, atk: AttackDef, dtSec: number,
  bounds: { leftWall: number; rightWall: number },
): number {
  const cl = atk.comboLunge
  if (!cl) return boss.x
  const h = boss.comboHitIndex
  if (h >= cl.plantFromHit) return boss.x   // 停止
  const dir = boss.facing === 'right' ? 1 : -1
  let vx: number   // committed dir を正とした速度 (px/s)
  if (h < cl.followHits) {
    // 追尾: プレイヤーの range-buffer 手前へ、 残距離を埋める速度 (上限 followSpeed)。 残りに比例=ease-out で寄る。
    const buffer = atk.gapCloseBuffer ?? BOSS.gapCloseBuffer
    const target = player.x - dir * Math.max(0, attackApproachDistance(atk) - buffer)
    const remFwd = (target - boss.x) * dir             // 前方向の残り (負なら既に通過=追わない)
    vx = Math.max(0, Math.min(cl.followSpeed, remFwd / Math.max(dtSec, 1e-4)))
    // 剣舞 v2: 入りでゆっくり上げ、着く手前で減速する (連撃の間の頭からの経過で上げる・残りに比例して落とす)。
    if (cl.glideRampMs) vx = Math.min(vx, cl.followSpeed * Math.min(1, boss.stateElapsed * 1000 / cl.glideRampMs))
    if (cl.glideBrakePerSec) vx = Math.min(vx, Math.max(0, remFwd) * cl.glideBrakePerSec)
  } else {
    // 前進コミット: 基準速 × spin進行の山型ease (入りで加速・plant手前で減速)。 プレイヤーは追わない。
    //   底は 0.72 = 最低でも 129.6px/s (advanceSpeed180 時) でプレイヤー後退(120px/s)を上回る
    //   → 同じ側へ逃げる相手を離さず張り付ける (§②「③後退=張り付き」)。
    const span = Math.max(1, cl.plantFromHit - cl.followHits)
    const prog = Math.min(1, Math.max(0, (h - cl.followHits + 0.5) / span))
    vx = cl.advanceSpeed * (0.72 + 0.28 * Math.sin(Math.PI * prog))   // 底72% + 山
  }
  let nx = boss.x + dir * vx * dtSec
  // すり抜け防止 (§②): プレイヤーが「進む向きの前方」にいる時だけ体の手前 (minBodyDistance) で止める。
  //   立ってる相手には目の前で止まり (270px 通過が消える)、 逃げる相手には背中に張り付く。
  //   プレイヤーが背後 (④背面抜け) にいる時は clamp しない = そのまま離れて進む = flank 窓を残す。
  const fwdToPlayer = (player.x - boss.x) * dir      // 前方向のプレイヤー距離 (負=背後)
  if (!attackStopAtReach && fwdToPlayer > 0) {
    const maxFwd = Math.max(0, fwdToPlayer - COLLISION.minBodyDistance)
    const fwdNew = (nx - boss.x) * dir
    if (fwdNew > maxFwd) nx = boss.x + dir * maxFwd
  }
  if (attackStopAtReach) nx = clampToBossCoreFront(nx, boss.x, player.x, dir, atk, boss)
  return Math.max(bounds.leftWall, Math.min(bounds.rightWall, nx))
}

export function attackApproachDistance(atk: AttackDef): number {
  if (atk.approachDistancePx != null) return atk.approachDistancePx
  // collisionDraft は後半ボス移行中の明示的な旧契約。接近距離も旧rangeを使う。
  if (atk.collisionDraft) return atk.range
  throw new Error(`[approach] missing authored distance: ${atk.id}`)
}

export function computeLungeTargetX(boss: Boss, player: Player, atk: AttackDef): number {
  const studyTarget = awokenRushStudyTarget(boss, player, atk)
  if (studyTarget !== undefined) {
    const bounds = arenaBoundsFor(boss.id)
    return Math.max(bounds.leftWall, Math.min(bounds.rightWall, studyTarget))
  }
  const dir = boss.facing === 'right' ? 1 : -1
  const lungeDistance = awokenFinaleLunge(boss, player, atk)
  const plantedTarget = plantedTravelTarget(boss, player, atk, lungeDistance)
  if (plantedTarget !== undefined) return plantedTarget
  if (lungeDistance <= 0) return boss.x

  let target: number
  if (atk.wallContactInsetPx != null) {
    const walls = arenaBoundsFor(boss.id)
    const inset = Math.min(atk.wallContactInsetPx, (walls.rightWall - walls.leftWall) / 2)
    // すでに接触点より壁側にいる時は、その場で壁を捉える。逆走はしない。
    target = dir < 0 ? Math.min(boss.x, walls.leftWall + inset) : Math.max(boss.x, walls.rightWall - inset)
  } else if (atk.crossArena) {
    if (usesKnightSpearSpacing(boss) && atk.id === 'lanceCross') return boss.x
    const wc = arenaWalls()
    const arenaCenter = (wc.leftWall + wc.rightWall) / 2
    if (atk.crossArenaActiveStepPx != null) {
      // 限定ステップ: active 中は中央方向へ crossArenaActiveStepPx だけ踏み出す。
      //   残りの中央復帰は recoveryRecenter が担う (lanceCross「切り下がり」専用)。
      const dirToCenter = boss.x >= arenaCenter ? -1 : 1
      target = boss.x + dirToCenter * atk.crossArenaActiveStepPx
    } else {
      // 従来: active 中にアリーナ中央まで一気に移動
      target = arenaCenter
    }
  } else if (atk.positionEvadable) {
    // 位置避け可: 純粋に前方へ lungeDistance (プレイヤー追従なし)
    target = boss.x + dir * lungeDistance
  } else if (!attackStopAtReach && awokenBiteLandingGapPx(boss, atk) !== undefined) {
    // 覚醒王の噛み (2026-09-26 ユーザー裁定「懐を安全にして直して」): 口が主人公に重なる所で止まる
    //   (行き過ぎない)。主人公が懐 (口より内側) にいれば踏み込まず、その噛みは空振りする。
    //   却下版 reach (DEV の過去比較) は従来の式のまま再現する。
    const rawStep = (player.x - boss.x) * dir - awokenBiteLandingGapPx(boss, atk)!
    target = boss.x + dir * Math.max(0, Math.min(lungeDistance + BOSS.lungeCatchUp, rawStep))
  } else {
    const knightGap = usesKnightSpearSpacing(boss) ? knightSpearLungeGap(atk) : null
    // 据えの一打の比較版 (DEV ?maulSetGap=1・src/exec_maulset_stop.ts): 3段とも主人公の手前 65px より内側へは寄らない。
    //   近すぎる時は踏み込み 0 (その場で振る・下がらない)。off (既定・配布版) は undefined = 今のまま。
    const maulSetStop = maulSetStopFor(boss, atk)
    // 位置避け不可: strikeとは独立した approachDistance-buffer 手前を着地点に
    const buffer = atk.gapCloseBuffer ?? BOSS.gapCloseBuffer
    const baseDist = knightGap ?? Math.max(0, attackStopAtReach && atk.approachStopGapPx != null
      ? bossAttackStopGap(boss, atk) ?? attackApproachDistance(atk) - buffer
      : attackApproachDistance(atk) - buffer)
    const desiredDist = maulSetStop !== undefined ? Math.max(baseDist, maulSetStop) : baseDist
    const desiredTarget = player.x - dir * desiredDist
    // 既定は導入前の最低前進。却下版のreach比較だけ通常技の最低前進をなくす。
    const rawStep = (desiredTarget - boss.x) * dir
    const maxStep = lungeDistance + BOSS.lungeCatchUp
    const minStep = knightGap !== null || maulSetStop !== undefined || attackStopAtReach && !atk.passThroughBody
      ? 0 : lungeDistance * BOSS.minLungeFrac
    const clampedStep = Math.max(minStep, Math.min(maxStep, rawStep))
    target = boss.x + dir * clampedStep
  }
  const b = bossBodyBoundsFor(boss.id)
  return Math.max(b.leftWall, Math.min(b.rightWall, target))
}

export function wallReboundFacing(boss: Pick<Boss, 'id' | 'x'>): Boss['facing'] {
  const walls = arenaBoundsFor(boss.id)
  return boss.x < (walls.leftWall + walls.rightWall) / 2 ? 'right' : 'left'
}

function enterState(boss: Boss, state: BossState, patch: Partial<Boss>): BossUpdateResult {
  if (state === 'idle' && usesKnightSpearSpacing(boss)) boss = { ...boss, knightCloseConsidered: false }
  if (state !== 'idle' && usesKnightSpearSpacing(boss)) boss = { ...boss, knightInsideIdleMs: 0, knightPostAttackRespace: undefined }
  if (state === 'idle' && usesKnightSpearSpacing(boss)
    && (boss.currentAttack?.id === 'lanceThrust' || boss.currentAttack?.id === 'lanceSweep')) {
    boss = { ...boss, knightRetreating: false, knightRetreatHoldMs: 0, knightPostAttackHoldMs: 600,
      knightPostAttackRespace: 'pending' }
  }
  if (state !== 'idle') boss = clearAwokenSpacing(clearNeutralMovement(boss))
  if (boss.whiffCarry) { const { whiffCarry: _carry, ...rest } = boss; boss = rest }   // 回復1回限り
  if (boss.pocketRetreat) { const { pocketRetreat: _r, ...rest } = boss; boss = rest }   // 待機の一手だけ
  if (boss.bladeBackStep) { const { bladeBackStep: _b, ...rest } = boss; boss = rest }   // 剣舞の足を留めた1歩 (DEV ?bladeBackStep=lock) は待機の中だけ
  // 打ち切った戻りの早回し・宙から降りる高さ (src/stun_cut.ts) は、その状態の間だけ (入る時は patch がもう一度立てる)。
  if (boss.cutRecovery) { const { cutRecovery: _s, ...rest } = boss; boss = rest }
  if (boss.finisherDropFromPx !== undefined) { const { finisherDropFromPx: _d, ...rest } = boss; boss = rest }
  if (state === 'telegraph' && boss.attackConnected) { const { attackConnected: _hit, ...rest } = boss; boss = rest }
  // 背後の応手の連続数: 待機か普段の技に入ったら数え直す (応手に入る時だけ patch が +1 で上書きする)。
  if ((state === 'idle' || state === 'telegraph') && boss.backResponseChain) { const { backResponseChain: _c, ...rest } = boss; boss = rest }
  const transitionBoss = boss.exec && state !== 'idle'
    ? {
      ...boss,
      exec: {
        ...boss.exec,
        step: null,
        ...(state === 'telegraph' ? { consecutiveKeepDistanceRetreats: 0 } : {}),
      },
    }
    : boss
  return {
    // telegraph 突入 = 新しい攻撃の読みが始まる → 密着滞在の計測と連撃ヒット番号をリセット
    //   (per-attack 計測。 behindMs と同思想。 comboHitIndex 残留は 2026-07-06 実測: 前のA2の「1」が
    //    次攻撃の telegraph に残り、 hitIndex 付きタイムラインの絵選択を汚染しうる)
    //   greedHitCount も同じ理由でリセット (AttackDef.greedSwitch の発動条件・2026-08-31)。
    boss: { ...transitionBoss, ...(state === 'telegraph' ? { proximityHeldMs: 0, comboHitIndex: 0, greedHitCount: 0 } : null), ...patch, state, stateElapsed: 0 },
    enteredActive: false,
  }
}

// 攻撃選択ロジック (2026-06-02 改修: ラウンドロビン → 重み付きランダム):
//   - 直前と同じ攻撃は重みを下げる (連続回避。 ただし完全排除しない=2択ボスが強制交互で
//     かえってメトロノーム化するのを防ぐ)。
//   - 距離で重み付け: 遠い=突進(lunge)寄り / 近い=近接寄り。
//   - 壁際で届かない lunge は重み 0 (壁張り付き防止)。
//   → 固定順の「一定な攻撃」感を消し、 読めるけどループしない手触りに。
export function pickNextAttack(boss: Boss, player: Player, pool: string[]): AttackDef {
  if (pool.length === 0) return getAttack('houndBite')
  const altToken = nextAltToken(boss)
  if (altToken && ATTACKS[altToken]) return getAttack(altToken)
  if (pool.length === 1) return getAttack(pool[0]!)
  const dist = Math.abs(boss.x - player.x)
  const dir = player.x < boss.x ? -1 : 1

  const weights = pool.map((id) => {
    const a = getAttack(id)
    const lunge = isLungeAttack(id)
    let w = 1
    if (a.preferClose) w *= dist <= 140 ? 1.8 : 0.15   // 至近技は近くでだけ (§4.2)
    if (a.farOnlyPx !== undefined && dist < a.farOnlyPx) w = 0   // 離れた時だけの技 (他に出せる技が無ければ下の total<=0 で先頭へ)
    if (lunge) {
      w *= dist > 220 ? 2.2 : dist > 140 ? 1.1 : 0.5          // 遠い=突進寄り
      // 壁際で踏み込みが収まらない突進は弱める。 0 にすると選択肢が1個に減り
      //   「同じ攻撃ループ」になるバグの原因だったので、 完全排除はしない
      //   (踏み込み量は active 側でアリーナにクランプされ壁にめり込まない)。
      if (!lungeFitsInArena(boss.x, a, dir)) w *= 0.25
    } else {
      w *= dist > 240 ? 0.6 : 1.0                             // 遠いと近接は出にくく
    }
    if (id === boss.lastAttackId) w *= 0.35                    // 連続は出にくいが皆無にしない
    return w
  })
  // ハード上限: 同じ攻撃が既に2連続なら3連続目を禁止 (他に出せる攻撃がある限り)。
  //   重みrandom だけだと稀に長い連続が出る (独立試行) ため、 構造的に最大2連続で頭打ちにする。
  if (boss.lastAttackStreak >= 2 && boss.lastAttackId != null) {
    const otherSum = pool.reduce((s, id, i) => s + (id === boss.lastAttackId ? 0 : weights[i]!), 0)
    if (otherSum > 0) {
      for (let i = 0; i < pool.length; i += 1) {
        if (pool[i] === boss.lastAttackId) weights[i] = 0
      }
    }
  }

  const total = weights.reduce((s, w) => s + w, 0)
  if (total <= 0) return getAttack(pool[0]!)
  let r = Math.random() * total
  for (let i = 0; i < pool.length; i += 1) {
    r -= weights[i]!
    if (r <= 0) return getAttack(pool[i]!)
  }
  return getAttack(pool[pool.length - 1]!)
}

// G-3: 重み付きランダムの *手前* で「今出せる連」を決める純関数 (決定的=テスト可能)。
//   ① 部屋解禁: boss.executesTaken >= unlockAtExecutes の連だけ (未指定=0=常時)。
//      strings 持ちボスが attackPool の unlockByExecutes を迂回していた問題の修正。
//   ② 反復抑制: 直近と同じ連は除く (他に出せる連がある限り)。 同一連の連続で学習曲線が荒れるのを防ぐ。
//   ③ 壁際フィルタ (2026-06-16): requiresBossNearWall:true の連は bossX が端から WALL_BAND 以内の時だけ。
//      bossX を渡さない旧呼び出しは壁際フィルタを適用しない (後方互換)。
//   ④ 壁側プレイヤーフィルタ (2026-06-18): requiresPlayerWallSide:true の連は playerX が bossX の壁側の時だけ。
//      左壁=player.x<boss.x / 右壁=player.x>boss.x。 playerX を渡さない旧呼び出しはフィルタを適用しない (後方互換)。
//   200px = 騎士の preferredRange(230) で自然停止する壁側位置 (~190px) をカバーする最小帯。
export const WALL_BAND = 200
// C-6: lanceCross 発動後、この数だけ別 string を挟むまで再発動しない。
//   2 だと往復感が残りやすく、4 以上だと壁固定解消が遅れるため 3 が初期値。
export const CROSS_ARENA_LOCKOUT_ATTACKS = 3
export type StringSelectionMode = 'normal' | 'blink'
export function availableStrings(
  strings: BossString[], executesTaken: number, lastStringId: string | null | undefined,
  bossX?: number,
  playerX?: number,
  mode: StringSelectionMode = 'normal',
  _insideIdleMs = 0,
): BossString[] {
  const ws = arenaWalls()
  const nearWall = bossX !== undefined && (
    bossX <= ws.leftWall + WALL_BAND || bossX >= ws.rightWall - WALL_BAND
  )
  const arenaCenter = (ws.leftWall + ws.rightWall) / 2
  const unlocked = strings.filter((s) => {
    if (mode === 'blink' ? s.blinkOnly !== true : s.blinkOnly === true) return false
    if ((s.unlockAtExecutes ?? 0) > executesTaken) return false
    if (s.maxExecutes != null && executesTaken > s.maxExecutes) return false
    if (s.id === 'knight-threshold-shove') return false   // 近い時の薙ぎの差し替えだけが選ぶ
    const spearCross = s.id === 'knight-threshold-cross' && getKnightSpacing() === 'spear'
    if (spearCross && getKnightBackoff() === 'mix') return false
    if (spearCross) {
      if (bossX === undefined || playerX === undefined) return false
      const room = knightRoomBehind(bossX, playerX)
      if (room < KNIGHT_CROSS_WALL_ROOM_PX
        ? Math.abs(playerX - bossX) >= 110
        : Math.abs(playerX - bossX) >= KNIGHT_RETREAT_TRIGGER_PX) return false
    }
    // 離れている時だけの技 (farOnlyPx・例 剣舞の暗器投げ) で始まる連は、近い時に外す。
    const far = getAttack(s.beats[0]!.attackId).farOnlyPx
    if (far !== undefined && bossX !== undefined && playerX !== undefined && Math.abs(playerX - bossX) < far) return false
    if (!spearCross && s.requiresBossNearWall && bossX !== undefined && !nearWall) return false
    if (!spearCross && s.requiresPlayerWallSide && bossX !== undefined && playerX !== undefined) {
      // 左壁側: プレイヤーが boss より左 (壁方向) でなければ除外
      // 右壁側: プレイヤーが boss より右 (壁方向) でなければ除外
      const playerOnWallSide = bossX < arenaCenter ? playerX < bossX : playerX > bossX
      if (!playerOnWallSide) return false
    }
    return true
  })
  // 禁止済みの幕/通常外stringへ静かに戻さない。空はデータ不整合として呼び出し側で明示failする。
  if (unlocked.length === 0) return []
  if (unlocked.length === 1) return unlocked
  // blink分岐は1:1の独立抽選。直前分岐を除外して強制交互にしない。
  if (mode === 'blink') return unlocked
  const fresh = unlocked.filter((s) => s.allowRepeat === true || s.id !== lastStringId)
  return fresh.length > 0 ? fresh : unlocked
}

function selectByWeight(boss: Boss, player: Player, pool: BossString[]): BossString {
  if (pool.length === 1) return pool[0]!
  const dist = Math.abs(boss.x - player.x)
  // 2026-07-01 (B): blinkFollowupPending 中は距離ゾーン補正を無視して全等分抽選 = ワープ後の
  //   1 手だけ「奇襲」 として予測不能にする (ユーザー指摘: ワープ後は距離的に 1 パターンに寄る)。
  const followup = boss.blinkFollowupPending === true
  // 距離ゾーン (2026-07-01 花嫁向け): 近 ≤140 / 中 140-280 / 遠 >280
  //   preferClose/preferMid/preferFar が指定された連は「合致ゾーンで 1.8倍・外で 0.15倍」。
  //   複数指定は OR (どれか合致で 1.8倍)。
  const zoneClose = dist <= 140
  const zoneMid = dist > 140 && dist <= 280
  const zoneFar = dist > 280
  // 覚醒王 (09-27 採用・旧は DEV `?spacing=old`): 距離帯 (近・中・遠) の重みと「攻撃に入れる距離」で選ぶ。
  const spacing = usesAwokenSpacingChoice(boss)
  const weights = pool.map((s) => {
    if (spacing) return spacingWeight(s, dist)
    let w = s.weight
    if (!followup) {
      const hasZone = s.preferClose || s.preferMid || s.preferFar
      if (hasZone) {
        const inZone = (s.preferClose && zoneClose)
          || (s.preferMid && zoneMid)
          || (s.preferFar && zoneFar)
        w *= inZone ? 1.8 : 0.15
      }
    }
    // 騎士の幕3は連が主体 (10-02 ユーザー)。単発の突き・払いの重みを下げる。
    if (usesKnightSpearSpacing(boss)) w *= knightStringWeightMul(s.id, boss.executesTaken, boss.roomCount)
    return w
  })
  const total = weights.reduce((a, b) => a + b, 0)
  if (total <= 0) return pool[0]!
  let r = Math.random() * total
  for (let i = 0; i < pool.length; i += 1) {
    r -= weights[i]!
    if (r <= 0) return pool[i]!
  }
  return pool[pool.length - 1]!
}

// P3 string 選択 (ブループリント §3): 解禁+反復抑制で絞った候補から重み付きランダム。
//   preferClose の連は至近でだけ出す。 requiresBossNearWall/requiresPlayerWallSide は boss.x/player.x でフィルタ。
function pickNextString(
  boss: Boss, player: Player, strings: BossString[], mode: StringSelectionMode = 'normal',
): BossString {
  // DEV ?altAttacks (2026-10-08): 指定の技・連を順番に出す。見つからない要素は飛ばして通常選択へ (戦闘を止めない)。
  if (mode !== 'blink') {
    const token = nextAltToken(boss)
    // 技から外した連 (altOnlyStrings・例 戴冠獣の三連) も直接指定なら出す。通常の連を先に探す。
    const alt = token ? altStringFor(token, [...strings, ...(getBossDefinitionById(boss.id)?.altOnlyStrings ?? [])]) : undefined
    if (alt) return alt
  }
  // DEV 単独化 (2026-07-07): 指定 id の連だけを出す。 解禁 (unlockAtExecutes) より優先 =
  //   幕3の連も幕1から強制再生できる。 見つからなければ通常選択 (戦闘を止めない)。
  if (debugSoloStringId) {
    const solo = strings.find((s) => s.id === debugSoloStringId
      && (mode === 'blink' ? s.blinkOnly === true : s.blinkOnly !== true))
    if (solo) return solo
  }
  // 懐の噛みを外して空になる = 壁を背にして下がれない時 (下がれるなら boss.ts の待機が先に下がる)。
  //   その時は反復抑制・初登場の保証を外してでも噛み以外 (突進など) を出す。それも無ければ外す前の候補 (空振りで見せる)。
  const pocketed = stringCandidates(boss, player, strings, mode)
  const pocketFallback = pocketed.length > 0 ? []
    : withoutAwokenPocketBites(boss, player, availableStrings(strings, boss.executesTaken, null, boss.x, player.x, mode))
  let candidates = pocketed.length > 0 ? pocketed
    : pocketFallback.length > 0 ? pocketFallback : stringCandidates(boss, player, strings, mode, false)
  if (usesKnightSpearSpacing(boss) && boss.lastCrossArenaAttackCount !== undefined
    && boss.attackCount - boss.lastCrossArenaAttackCount < CROSS_ARENA_LOCKOUT_ATTACKS) {
    const unlocked = candidates.filter((s) => s.id !== 'knight-threshold-cross')
    if (unlocked.length > 0) candidates = unlocked
  }
  if (candidates.length === 0) {
    throw new Error(`[strings] no ${mode} candidate for ${boss.id} at executes=${boss.executesTaken}`)
  }
  // 壁際固定を解消する優先補正 (2026-06-16):
  //   requiresBossNearWall の連が candidates に入っている = availableStrings が nearWall を確認済み。
  //   重み抽選より前に確定で返す (壁際での横断を確実に出す)。
  //   直前が同じ連なら availableStrings の反復抑制で既に除外されているので連続しない。
  const wallPriority = candidates.find((s) => s.requiresBossNearWall
    && !(s.id === 'knight-threshold-cross' && getKnightSpacing() === 'spear'))
  if (wallPriority) {
    // C-6 ロックアウト: 直近 CROSS_ARENA_LOCKOUT_ATTACKS 回以内なら壁際優先を封じる。
    //   lastCrossArenaAttackCount 未定義 = まだ一度も撃っていない → 封じない。
    const lockedOut = boss.lastCrossArenaAttackCount !== undefined
      && (boss.attackCount - boss.lastCrossArenaAttackCount) < CROSS_ARENA_LOCKOUT_ATTACKS
    if (!lockedOut) return wallPriority
    // ロックアウト中: requiresBossNearWall の連を除いた残りから通常選択へ。
    const nonWallCandidates = candidates.filter((s) => !s.requiresBossNearWall)
    if (nonWallCandidates.length > 0) {
      // nonWallCandidates で weight 選択を続ける (wallPriority は skip)。
      return selectByWeight(boss, player, nonWallCandidates)
    }
    // 非壁際候補が無い (理論上起きないが念のため)。
    return wallPriority
  }
  // 覚醒王 (09-27 採用・旧は DEV `?spacing=old`): 今の距離から届く連だけで選ぶ (待機の一手が届く所まで来てから呼ばれる)。
  if (usesAwokenSpacingChoice(boss)) {
    const dist = Math.abs(boss.x - player.x)
    const reachable = candidates.filter((s) => spacingReaches(s, dist))
    if (reachable.length > 0) return selectByWeight(boss, player, reachable)
  }
  return selectByWeight(boss, player, candidates)
}

// 今出せる連 (道具・解禁・反復抑制・壁際・初登場の保証を通した候補)。抽選はしない (乱数を使わない)。
function stringCandidates(
  boss: Boss, player: Player, strings: BossString[], mode: StringSelectionMode = 'normal', pocket = true,
): BossString[] {
  // 請われぬ介錯だけ、現在の刃/砲に一致する譜面へ絞る。
  // requiresWeapon 未指定の譜面は道具を問わないため、他ボスは挙動不変。
  const held = boss.exec?.held
  // 幕1は executionerPool と同じく刃固定。ラボの形態切替などで held='cannon' が
  // 入っても、幕1に砲譜面だけが残って候補ゼロにならないようにする。
  const effectiveWeapon = boss.exec && boss.executesTaken === 0 ? 'blade' : held
  const weaponScoped = effectiveWeapon
    ? strings.filter((s) => (s.requiresWeapon == null || s.requiresWeapon === effectiveWeapon)
      // 🔵 2026-09-04: 砲の譜面の組 (composed/single) を実行時に絞る (executioner_weapon.ts)。
      && executionerStringEnabled(s.id))
    : strings
  const candidates = rampageV5Debut(boss, availableStrings(weaponScoped, boss.executesTaken, boss.lastStringId,
    boss.x, player.x, mode, boss.knightInsideIdleMs ?? 0))
  // 覚醒王: 懐 (口が届かない距離) の相手には、噛みから始まる連を出さない (2026-09-26 ユーザー裁定)。
  return pocket ? withoutAwokenPocketBites(boss, player, candidates) : candidates
}

// 覚醒王: 今出せる連が全部「懐で届かない噛み」なら、下がって止まる間合いを返す (噛み以外が出せるなら undefined)。
//   force = 噛み以外が出せても下がる (09-27 採用の間合いの一手で、体の芯に重なっている時だけ)。
/** 顔を見せる間合い (DEV ?awokenFaceRoom=1・src/awoken_face_room.ts)。届く距離の 10px 手前を超えない。配布版は undefined。 */
function faceRoomFor(reachPx: number): number | undefined {
  // DEV ?awokenBiteSpace=keep (src/awoken_bite_space.ts) も同じ後ろ歩きで好みの距離を取る。
  const room = awokenFaceRoomPx() ?? awokenBiteSpaceRoomPx()
  return room === undefined ? undefined : Math.min(room, reachPx - 10)
}

function awokenPocketRetreatTarget(boss: Boss, player: Player, strings: BossString[] | undefined, capPx: number, force = false): number | undefined {
  if (boss.id !== 'crowned-king-awoken' || debugBypassStrings || debugSoloStringId || !strings || strings.length === 0) return undefined
  const all = stringCandidates(boss, player, rampageV5Strings(boss, awokenFinaleStrings(boss, player, strings)), 'normal', false)
  if (all.length === 0 || (!force && withoutAwokenPocketBites(boss, player, all).length > 0)) return undefined
  return awokenPocketRetreatGapPx(all, beat => beat.chargeOverrideMs ?? getAttack(beat.attackId).chargeMs, capPx)
}

function isLungeAttack(id: string): boolean {
  const a = ATTACKS_CACHE[id] ?? getAttack(id)
  ATTACKS_CACHE[id] = a
  return a.lungeDistance != null && a.lungeDistance > 0
}

// lungeすると壁にぶつからないか
const WALL_MARGIN = 30
function lungeFitsInArena(currentX: number, atk: AttackDef, dir: number): boolean {
  const targetX = currentX + dir * (atk.lungeDistance ?? 0)
  const w = arenaWalls()
  return targetX >= w.leftWall + WALL_MARGIN && targetX <= w.rightWall - WALL_MARGIN
}

const ATTACKS_CACHE: Record<string, AttackDef> = {}

// ボス定義から固有フィニッシャーを取得 (気絶中の致命攻撃)
function getBossFinisher(bossId: string): AttackDef | null {
  // 稽古の比較版 (DEV ?tutFocus・src/tut_focus.ts) の課題の間だけ、亡霊にも決め技がある (src/exec_parry.ts bossFinisherAttackId)。
  const id = bossFinisherAttackId(bossId)
  if (!id) return null
  return getAttack(id)
}

// 致命に入る時の技。覚醒王の比較版「灰を食む」(DEV ?awokenDevour) が入っている時だけ、この回の段取りを載せた写しを返す。
//   スイッチが無ければ getBossFinisher と同じ物 (今のまま)。
function getBossFinisherFor(boss: Boss, player: Player, bounds: { leftWall: number; rightWall: number }): AttackDef | null {
  const finisher = getBossFinisher(boss.id)
  // 騎士と花嫁の固有の致命 (DEV ?execUnique=1 と ?execParry・src/exec_unique.ts): この回の段取りを載せた写し。背中側の壁は体の壁で測る。
  if (finisher && execUniqueOn(boss.id)) {
    const body = bossBodyBoundsFor(boss.id)
    const awayDir = boss.x >= player.x ? 1 : -1
    let roomBehind = awayDir > 0 ? body.rightWall - boss.x : boss.x - body.leftWall
    // 主人公の向こう側 (騎士の壁ぎわの駆け抜けで回り込む先) の、主人公の中心から壁までの残り。
    let roomPast = awayDir > 0 ? player.x - body.leftWall : body.rightWall - player.x
    // 騎士: カメラが止まっている部屋 (舞台の幅が普段のまま) では、背中側の絵の張り出し (K2 の外套の端) が画面の端に掛からない所で止まる (10-09 夜)。
    if (boss.id === 'vigil-knight' && getArenaWidthMul() === 1) {
      const ext = KNIGHT_BACKTURN.screenBackExtentPx
      roomBehind = Math.min(roomBehind, awayDir > 0 ? (ARENA.width - ext) - boss.x : boss.x - ext)
      roomPast = Math.min(roomPast, awayDir > 0 ? player.x - ext : (ARENA.width - ext) - player.x)
    }
    const unique = execUniqueAttack(boss.id, finisher, Math.abs(player.x - boss.x), roomBehind, roomPast)
    if (unique) return unique
  }
  // 剣舞の幕引きの一閃の作り直し (src/blade_finisher_v2.ts・既定・前の版は DEV ?bladeFinisher=v1): 手拍子→V 字→斬り・返し斬りの2撃。
  if (finisher && boss.id === 'blade-dancer' && bladeFinisherV2On()) return bladeClapAttack(finisher)
  if (!finisher || !awokenDevourEnabled() || boss.id !== 'crowned-king-awoken' || finisher.id !== AWOKEN_DEVOUR_BASE_ID) return finisher
  const dir = boss.x >= player.x ? -1 : 1
  const roomBehind = dir > 0 ? player.x - bounds.leftWall : bounds.rightWall - player.x
  return awokenDevourAttack(finisher, Math.abs(player.x - boss.x), roomBehind, Math.random, boss.altitudePx ?? 0)
}

// 騎士と花嫁の固有の致命 (DEV ?execUnique=1・src/exec_unique.ts) の、当たった後の体の位置 (当たった所 = actionAnchorX から)。
//   騎士の突進 (charge): 当たったら勢いで少し前へ滑って止まる・弾かれたら後ろへのけぞりながら下がる。前の版 (band) は動かない。
//   花嫁 (glide): 弾かれたら後ろへ押し返されて滑る。弾かれていない時・old は動かない (覆い被さる寄りは brideCoverGapAt)。
function execUniqueAfterX(boss: Boss, plan: ExecUniquePlan, afterMs: number, bounds: { leftWall: number; rightWall: number }): Boss {
  const fwd = boss.facing === 'right' ? 1 : -1
  let shift = 0
  if (plan.boss === 'vigil-knight') {
    if (plan.form !== 'charge') return boss
    shift = knightChargeAfterShiftPx(plan, afterMs)
  } else {
    if (!plan.parried) return boss
    shift = -brideParriedShiftPx(plan, afterMs)
  }
  return { ...boss, x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, boss.actionAnchorX + fwd * shift)) }
}

export function staggerBoss(boss: Boss): Boss {
  return {
    ...boss,
    state: 'staggered',
    stateElapsed: 0,
    currentAttack: null,
    currentString: null,
    beatIndex: 0,
    // 変形中に体幹を崩されたら変形は不成立。held は元の形態のまま維持する。
    ...(boss.exec
      ? { exec: {
          ...boss.exec,
          morph: 'no' as const,
          morphElapsedMs: 0,
          morphTurnRequired: null,
          step: null,
          backstepCooldownMs: 0,
        } }
      : null),
  }
}

// ============================================================================
// 🔴 2026-08-13 夜 却下＝set_backstep の前傾姿勢のまま x を動かすと滑って見える。
// 戻し方＝executioner_weapon.ts の ARCHIVED_EXECUTIONER_MORPH_BACKOFF_2026_08_13 を
// transform へ戻し、下の分岐を上の morphing 節へ復元する。
//
// const backOffStepMs = Math.min(
//   morphStepMs,
//   Math.max(0, EXECUTIONER.transform.backOffMs - morphExec.morphElapsedMs),
// )
// if (backOffStepMs > 0) {
//   const away: 1 | -1 = next.x >= player.x ? 1 : -1
//   let x = next.x + away * EXECUTIONER.transform.backOffSpeedPx * (backOffStepMs / 1000)
//   x = clampToBossCoreFront(x, next.x, player.x, away, null)
//   x = Math.max(bounds.leftWall, Math.min(bounds.rightWall, x))
//   next = { ...next, x }
// }
// ============================================================================
